import { blinkConstants } from '@thoughtspot/blink-constants';
import { getUpdatedFormatConfig } from '@thoughtspot/client-state-util';
import { getConfig } from '@thoughtspot/custom-style-service';
import { getNumericColumnFormatPattern, NULL_SUMMARY_MODE, } from '@thoughtspot/formatter-service';
import { translate } from '@thoughtspot/i18n';
import { userActionTypeEnum, userActionTypes } from '@thoughtspot/metrics';
import { PICKER_VIEW } from '@thoughtspot/radiant-react/widgets/colorpicker/colorpicker-menu';
import { DirectionType, HorizontalDirection, VerticalDirection, } from '@thoughtspot/radiant-react/widgets/direction-control/direction-control.types';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { FontItemID } from '@thoughtspot/radiant-react/widgets/segment-control/font-formatter/font-formatter-id';
import { Colors } from '@thoughtspot/radiant-react/widgets/typography/typography';
import { enableGridlines, isKPIChartEnhancementsEnabled, } from '@thoughtspot/session-service';
import { getTimeBucket, isGrowth, } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { ABOVE_EXPECTED_COLOR_INDEX, BELOW_EXPECTED_COLOR_INDEX, } from '../../../components/kpi/cortex-utils';
import { ErrorCodes, getCustomComparisonOptions, getDefaultAbbreviatedPreviousDateFromChartModel, getErrorDescriptionForCustomCompare, getErrorTitleForCustomCompare, getGenericCompareValueFromCustomProps, getKpiColumnCustomProps, getKpiColumnProperties, getRefTuple, mapTimeBucketToCategory, negativeComparisionColorIndex, parseCustomProps, positiveComparisionColorIndex, updateKpiColumnCustomPropsField, } from '../../../components/kpi/kpi-utils';
import { addAlphaToColor, getScaleFromColor, } from '../../../core/chart-color-utils';
import { getAxisConfig, getAxisForColumn, getAxisPropertiesById, getChartSpecificCustomProps, getChartType, getColorScaleOfMultiColorSeriesColors, getFirstAxis, getFormattingForAxis, getSortedColumnsIdOfType, getSortFormatFromColumn, getVisualizedMeasureColumns, getXAxisColumns, getXAxisColumnsHash, getYAxisColumns, setColorScaleOfMultiColorSeriesColors, } from '../../../core/chart-model-utils';
import { chartSpecificConstants, configOptions, } from '../../../core/chart-type-specification-service';
import { getGridLinesConfig } from '../../../core/chart-ui-utils';
import { getName } from '../../../core/column-name-util';
import { getDefaultGradientColors } from '../../../core/conditional-formatting-utils';
import { getSummariesFormatConfig } from '../../../core/headline-utils';
import { containsMeasureNamesOrMeasureValuesColumns } from '../../../core/measure-names-and-values';
import { getLegendCardinality, getSerie } from '../../../data/data-util';
import { GEO_TILE_TYPES } from '../../../geomap/base/geo-constants';
import { AxisTypes, ChangeInterpretation, ChartResponsiveLayout, HandleMissingValues, HandleNullData, ShowChangeAs, ShowPivotSummaryPrior, TableTheme, TupleType, } from '../../../types';
import { ChartSettingsElementType, } from '../chart-settings-v2-schema.types';
import { getCandleStickChartColorItems, getDataWithColor, getKpiChartColorItems, getLegendDataValues, getRandomColorFromPalette, getUnifiedColorMap, getUnifiedMultiColorSeriesColors, } from '../common-utils';
import { getExtendedChartColorPalette } from './chart-color-palette-utils';
import { shouldDisableColumnSubtotalsCheckbox, shouldDisableDataLabelsVisibilityCheckbox, shouldDisableDisplaySummaryCheckbox, shouldDisableDisplayValueFormatDropdown, shouldDisableDisplayValuesRadioGroup, shouldDisableGridlineCheckbox, shouldDisableHeatmapModeCheckbox, shouldDisableInheritanceForAxis, shouldDisableInheritanceForDataLabel, shouldDisableLegendCheckbox, shouldDisableLegendPosition, shouldDisableMapTileDropdown, shouldDisableMissingDatesDropdown, shouldDisableRowSubtotalsCheckbox, shouldDisableShowAnomalyCheckbox, shouldDisableShowSubtotals, shouldDisableShowTotalsCheckbox, shouldDisableSortOrderRadioGroup, shouldDisableTooltipVisibilityCheckbox, shouldDisableTotalLabelsCheckbox, shouldDisableTotalsPositionRadioGroup, shouldHideAggregationDropdown, shouldHideAnomalyColorPicker, shouldHideAnomalySettings, shouldHideAxisHorizontalPositionControl, shouldHideAxisNameSettings, shouldHideAxisSettings, shouldHideAxisValueLabelNumberFormatter, shouldHideAxisValueLabelSettings, shouldHideBarWidthSettings, shouldHideChangeAsDropdown, shouldHideColumnColorPicker, shouldHideColumnDataColorsPicker, shouldHideColumnNumberFormatter, shouldHideComparisonSettings, shouldHideCustomComparisonInput, shouldHideDataLabelNumericFilter, shouldHideDataLabelSettings, shouldHideExcludeNullValuesCheckbox, shouldHideGradientColorPicker, shouldHideGridLineFromatter, shouldHideLineSeriesSettings, shouldHideMissingDatesDropdown, shouldHideNullAsZeroCheckbox, shouldHideRegressionLineFromatter, shouldHideShowAbbreviatedPreviousDateCheckbox, shouldHideShowAbbreviatedPreviousDateInput, shouldHideShowNullDataAsDropdown, shouldHideSortOrder, shouldHideSparklineColorPicker, shouldHideStackedAsPercentFormatter, shouldHideStackLabelAdvancedSettings, shouldHideTableSummaryNumberFormatter, shouldHideTableSummarySettings, shouldShowAbbreviatedPreviousDateError, } from './common-rules';
import { getGradientRange, isColumnGrandTotalsEnabled, isColumnSubTotalsEnabled, isRowGrandTotalsEnabled, isRowSubTotalsEnabled, MAPBOX_TILE_LABELS, updateDataLabelProperties, } from './common-utils';
import { createAccordionItem, createAxisRenameInput, createBackgroundFormatter, createChartZoom, createCheckbox, createCheckboxGroup, createColorPicker, createColumnRenameInput, createConditionalFormatter, createDropdown, createElement, createFontFormatter, createInheritanceWidget, createIntervalFormatter, createLabelledView, createLineFormatter, createMultilevelDropdown, createNumberFormatter, createNumberInput, createNumberRange, createNumericFilterInput, createPositionControl, createRadio, createRadioGroup, createSortFormat, createTextInput, } from './elements';
import { getMixpanelConfigForBackgroundStyle, getMixpanelConfigForBorderStyle, getMixpanelConfigForFontStyle, getMixpanelConfigForLineStyle, getNumberFormatMixPanelConfig, } from './mixpanel-utils';
export const createTimeBucketDropdown = (options = {}) => {
    return createLabelledView({
        properties: {
            label: 'TIME_BUCKET',
            childrenSize: 'large',
        },
        children: [
            createMultilevelDropdown({
                key: 'timeBucket',
                isAnswerProperty: true,
                runTimeProperties: {
                    schema: 'TS_INPUT',
                },
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_TIME_BUCKET,
                        properties: {
                            timeGrain: updatedValue,
                            source: userActionTypes.CHANGE_TIME_BUCKET.actionParams
                                .source.CONFIG_PANEL,
                        },
                    };
                },
            }),
        ],
        translate: ['label'],
        ...options,
    });
};
export const createColumnNameTextInput = () => {
    return createColumnRenameInput({
        key: 'name',
        isAnswerProperty: true,
        properties: {
            value: '',
        },
        parseValueToComponent: ({ column }) => {
            return getName(column);
        },
    });
};
export const createTableColumnNumberFormatter = (options = {}) => {
    return createNumberFormatter({
        key: 'columnProps.columnProperties.format',
        isAnswerProperty: true,
        properties: {
            typeProps: {
                ariaLabel: 'number-type',
            },
            subTypeProps: {
                ariaLabel: 'number-subtype',
            },
            formatProps: {
                ariaLabel: 'number-format',
            },
        },
        runTimeProperties: {
            customFormatPattern: 'TS_INPUT',
            isCustomCurrency: 'TS_INPUT',
        },
        parseValueToComponent: ({ column }) => {
            var _a, _b;
            return ((_b = (_a = column.columnProps.columnProperties) === null || _a === void 0 ? void 0 : _a.format) !== null && _b !== void 0 ? _b : getNumericColumnFormatPattern(column));
        },
        parseValueFromComponent: formtConfig => {
            return getUpdatedFormatConfig(formtConfig);
        },
        getMixpanelConfig: ({ updatedValue, previousValue }) => {
            return getNumberFormatMixPanelConfig(updatedValue, previousValue, userActionTypes.NUMBER_FORMAT.actionParams.target.COLUMN);
        },
        isHiddenCallback: shouldHideColumnNumberFormatter,
        ...options,
    });
};
export const createChartColumnNumberFormatter = (options = {}) => {
    return createNumberFormatter({
        key: 'columnProps.columnProperties.format',
        isAnswerProperty: true,
        properties: {
            typeProps: {
                ariaLabel: 'number-type',
            },
            subTypeProps: {
                ariaLabel: 'number-subtype',
            },
            formatProps: {
                ariaLabel: 'number-format',
            },
        },
        runTimeProperties: {
            customFormatPattern: 'TS_INPUT',
            isCustomCurrency: 'TS_INPUT',
            typeProps: 'TS_INPUT',
        },
        parseValueToComponent: ({ column }) => {
            var _a, _b;
            const userDefinedFormat = (_a = column.columnProps.columnProperties) === null || _a === void 0 ? void 0 : _a.format;
            if (userDefinedFormat == null) {
                return getNumericColumnFormatPattern(column);
            }
            if (isGrowth(column)) {
                const defaultFormat = getNumericColumnFormatPattern(column);
                const userDefinedPercentageConfig = (_b = userDefinedFormat === null || userDefinedFormat === void 0 ? void 0 : userDefinedFormat.percentageFormatConfig) !== null && _b !== void 0 ? _b : null;
                if (userDefinedPercentageConfig != null) {
                    return {
                        ...defaultFormat,
                        percentageFormatConfig: {
                            ...defaultFormat.percentageFormatConfig,
                            ...userDefinedPercentageConfig,
                        },
                    };
                }
                return defaultFormat;
            }
            return userDefinedFormat;
        },
        parseValueFromComponent: formtConfig => {
            return getUpdatedFormatConfig(formtConfig);
        },
        getMixpanelConfig: ({ updatedValue, previousValue }) => {
            return getNumberFormatMixPanelConfig(updatedValue, previousValue, userActionTypes.NUMBER_FORMAT.actionParams.target.COLUMN);
        },
        isHiddenCallback: shouldHideColumnNumberFormatter,
        ...options,
    });
};
export const createSortOrderRadioGroup = (options = {}) => {
    const radioGroup = createRadioGroup({
        key: 'columnProps.columnProperties.sortConfig',
        isAnswerProperty: true,
        properties: {
            label: 'sort.ORDER_LABEL',
            id: 'sortConfig',
        },
        parseValueToComponent: ({ column }) => {
            return getSortFormatFromColumn(column);
        },
        children: [
            createRadio({
                properties: {
                    label: 'sort.FORMAT_ALPHANUMERIC',
                    value: 'DEFAULT',
                },
                translate: ['label'],
            }),
            createRadio({
                properties: {
                    label: 'DocumentType.WORKSHEET',
                    value: 'CUSTOM',
                },
                translate: ['label'],
            }),
        ],
        isDisabledCallback: shouldDisableSortOrderRadioGroup,
        translate: ['label'],
        ...options,
    });
    return createLabelledView({
        properties: {
            label: 'sort.ORDER_LABEL',
            orientation: 'Vertical',
        },
        children: [radioGroup],
        isHiddenCallback: shouldHideSortOrder,
        translate: ['label'],
    });
};
export const createChartSortFormat = (options = {}) => {
    const sortFormat = createSortFormat({
        properties: {
            vizType: 'ChartViz',
        },
        ...options,
    });
    return createLabelledView({
        properties: {
            label: 'SORT',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [sortFormat],
        isHiddenCallback: shouldHideSortOrder,
        translate: ['label'],
    });
};
export const createTableSortFormat = (options = {}) => {
    const sortFormat = createSortFormat({
        properties: {
            vizType: 'TableViz',
        },
        ...options,
    });
    return createLabelledView({
        properties: {
            label: 'SORT',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [sortFormat],
        isHiddenCallback: shouldHideSortOrder,
        translate: ['label'],
    });
};
export const createAggregationDropdown = (options = {}) => {
    return createLabelledView({
        properties: {
            label: 'Aggregation',
            childrenSize: 'large',
        },
        children: [
            createDropdown({
                key: 'aggregationType',
                isAnswerProperty: true,
                runTimeProperties: {
                    optionsGroups: 'TS_INPUT',
                },
                properties: {
                    label: 'spotter.atac.modal.select.aggregation',
                    value: '',
                    enableScroll: false,
                },
                translate: ['label'],
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.AGGREGATION_CHANGE,
                        properties: {
                            aggregationType: updatedValue,
                            source: userActionTypes.AGGREGATION_CHANGE.actionParams
                                .source.CONFIG_PANEL,
                        },
                    };
                },
            }),
        ],
        isHiddenCallback: shouldHideAggregationDropdown,
        isAdvanced: true,
        translate: ['label'],
        ...options,
    });
};
export const createShowNullDataAsDropdown = (options = {}) => {
    return createLabelledView({
        properties: {
            label: 'CHART_SETTINGS_SHOW_NULL_DATA_AS',
            childrenSize: 'large',
            orientation: 'Vertical',
        },
        children: [
            createDropdown({
                key: 'kpiColumnProperties.handleNullData',
                properties: {
                    label: 'CHART_SETTINGS_SHOW_NULL_DATA_AS',
                    optionsGroups: [
                        {
                            options: [
                                {
                                    id: HandleNullData.Zero,
                                    label: 'CHART_SETTINGS_SHOW_AS_ZERO',
                                },
                                {
                                    id: HandleNullData.NoDataFound,
                                    label: 'CHART_SETTINGS_NO_DATA_FOUND',
                                },
                            ],
                        },
                    ],
                    value: HandleNullData.Zero,
                    dropdownWidth: 'targetWidth',
                },
                translate: ['label', 'optionsGroups.options.label'],
            }),
        ],
        isAdvanced: false,
        isHiddenCallback: shouldHideShowNullDataAsDropdown,
        translate: ['label'],
        ...options,
    });
};
export const createMissingValuesDropdown = (options = {}) => {
    return createLabelledView({
        properties: {
            label: 'MISSING_DATES',
            childrenSize: 'large',
        },
        children: [
            createDropdown({
                key: 'handleMissingValues',
                properties: {
                    label: 'MISSING_DATES',
                    optionsGroups: [
                        {
                            options: [
                                {
                                    id: HandleMissingValues.DontShow,
                                    label: 'IGNORE',
                                },
                                {
                                    id: HandleMissingValues.ShowAsZero,
                                    label: 'TREAT_AS_ZERO',
                                },
                                {
                                    id: HandleMissingValues.ShowGap,
                                    label: 'SHOW_GAPS',
                                },
                            ],
                        },
                    ],
                    dropdownWidth: 'targetWidth',
                    value: 'DONT_SHOW',
                },
                translate: ['label', 'optionsGroups.options.label'],
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_HANDLE_MISSING_VALUES,
                        properties: {
                            type: updatedValue,
                        },
                    };
                },
                isDisabledCallback: shouldDisableMissingDatesDropdown,
            }),
        ],
        isAdvanced: true,
        isHiddenCallback: shouldHideMissingDatesDropdown,
        translate: ['label'],
        ...options,
    });
};
export const createShowNullAsZeroCheckbox = () => {
    return createCheckbox({
        key: 'handleMissingValues',
        properties: {
            label: 'charts.chartEditor.SHOW_NULL_AS_ZERO',
            value: true,
            'data-tooltip-content': 'charts.chartEditor.SHOW_NULL_AS_ZERO',
        },
        parseValueToComponent: ({ value }) => {
            return value === HandleMissingValues.ShowAsZero;
        },
        parseValueFromComponent: isChecked => {
            return isChecked
                ? HandleMissingValues.ShowAsZero
                : HandleMissingValues.DontShow;
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.CHANGE_HANDLE_MISSING_VALUES,
                properties: {
                    type: updatedValue
                        ? HandleMissingValues.ShowAsZero
                        : HandleMissingValues.DontShow,
                },
            };
        },
        isHiddenCallback: shouldHideNullAsZeroCheckbox,
        translate: ['label', 'data-tooltip-content'],
    });
};
const createGradientPickerV2 = (options = {}) => {
    return {
        elementType: ChartSettingsElementType.GRADIENT_PICKER_V2,
        key: 'gradient',
        parseValueToComponent: ({ chart, chartModel, column, value }) => {
            var _a, _b;
            const defaultColors = getDefaultGradientColors(chartModel, chart === null || chart === void 0 ? void 0 : chart.getDataModel());
            if (!defaultColors) {
                return null;
            }
            if (!value) {
                return {
                    colors: defaultColors,
                    range: getGradientRange(chartModel, column.id, defaultColors),
                    isAutoScaled: true,
                };
            }
            if (!value.colors || !value.range || value.isAutoScaled) {
                return {
                    colors: (_a = value.colors) !== null && _a !== void 0 ? _a : defaultColors,
                    range: getGradientRange(chartModel, column.id, (_b = value.colors) !== null && _b !== void 0 ? _b : defaultColors),
                    isAutoScaled: value.isAutoScaled,
                };
            }
            return value;
        },
        getMixpanelConfig: ({ updatedValue, previousValue }) => {
            return {
                eventName: userActionTypeEnum.SAVE_GRADIENT_FORMATTING,
            };
        },
        ...options,
    };
};
export const createKPISparklineColorPicker = (options = {}) => {
    return createLabelledView({
        properties: {
            orientation: 'Vertical',
            label: 'charts.chartEditorV2.KPI.SHOW_SPARKLINE_LABEL',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createSparklineCheckboxForKPI(),
            createColorPicker({
                key: 'columnColor',
                elementType: ChartSettingsElementType.COLOR_PICKER,
                runTimeProperties: {
                    value: 'CUSTOM',
                    colors: 'CUSTOM',
                },
                properties: {
                    value: '',
                },
                getRunTimeProperties: {
                    value: ({ currentProperties: columnColor = {
                        userDefined: [],
                        systemDefined: [],
                    }, }) => {
                        var _a, _b;
                        return ((_b = (_a = columnColor.userDefined) !== null && _a !== void 0 ? _a : columnColor.systemDefined) !== null && _b !== void 0 ? _b : '');
                    },
                    colors: () => {
                        var _a, _b, _c;
                        return ((_c = (_b = (_a = getConfig()
                            .getChartColorPalettes()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.getColors()) !== null && _c !== void 0 ? _c : []);
                    },
                },
                parseValueFromComponent: (newColor, columnColor) => {
                    return {
                        userDefined: newColor,
                        systemDefined: columnColor.systemDefined,
                    };
                },
                getMixpanelConfig: () => {
                    return {
                        eventName: userActionTypeEnum.COLOR_CHANGE,
                    };
                },
                isHiddenCallback: shouldHideSparklineColorPicker,
            }),
        ],
        isHiddenCallback: shouldHideColumnColorPicker,
        translate: ['label'],
        ...options,
    });
};
export const createGradientColorPicker = (options = {}) => {
    return createLabelledView({
        properties: {
            label: 'Gradient',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [createGradientPickerV2()],
        isHiddenCallback: shouldHideGradientColorPicker,
        translate: ['label'],
        ...options,
    });
};
export const createColumnColorPicker = (options = {}) => {
    return createLabelledView({
        properties: {
            label: 'chart.chartEditor.chartAxisConfigurator.COLOR',
        },
        children: [
            createColorPicker({
                key: 'columnColor',
                elementType: ChartSettingsElementType.COLOR_PICKER,
                runTimeProperties: {
                    value: 'CUSTOM',
                    colors: 'CUSTOM',
                },
                properties: {
                    value: '',
                },
                getRunTimeProperties: {
                    value: ({ currentProperties: columnColor = {
                        userDefined: [],
                        systemDefined: [],
                    }, }) => {
                        var _a, _b;
                        return ((_b = (_a = columnColor.userDefined) !== null && _a !== void 0 ? _a : columnColor.systemDefined) !== null && _b !== void 0 ? _b : '');
                    },
                    colors: () => {
                        var _a, _b, _c;
                        return ((_c = (_b = (_a = getConfig()
                            .getChartColorPalettes()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.getColors()) !== null && _c !== void 0 ? _c : []);
                    },
                },
                parseValueFromComponent: (newColor, columnColor, chartModel) => {
                    const chartConfigOptions = configOptions(chartModel.config.chartType, chartModel);
                    let updatedColor = newColor;
                    if (chartConfigOptions.useAlphaColors) {
                        updatedColor = addAlphaToColor(newColor);
                    }
                    return {
                        userDefined: updatedColor,
                        systemDefined: columnColor.systemDefined,
                    };
                },
                getMixpanelConfig: () => {
                    return {
                        eventName: userActionTypeEnum.COLOR_CHANGE,
                    };
                },
            }),
        ],
        isHiddenCallback: shouldHideColumnColorPicker,
        translate: ['label'],
        ...options,
    });
};
export const createColumnDataColorsPicker = (options = {}) => {
    return {
        elementType: ChartSettingsElementType.CHART_DATA_COLOR_PICKER,
        key: 'columnDataColors',
        runTimeProperties: {
            colorItems: 'CUSTOM',
        },
        properties: {
            colorItems: [],
        },
        getRunTimeProperties: {
            colorItems: ({ currentProperties: colummnDataColors = {
                userDefined: [],
                systemDefined: [],
            }, chartModel, dataModel, }) => {
                if (!dataModel)
                    return null;
                if (!colummnDataColors.userDefined) {
                    return [];
                }
                const legendDataValues = getLegendDataValues(chartModel, dataModel);
                const colorMap = getUnifiedColorMap(colummnDataColors.userDefined, colummnDataColors.systemDefined);
                return getDataWithColor(legendDataValues, colorMap);
            },
        },
        parseValueFromComponent: (updatedColorItems, columnDataColors, chartModel) => {
            let colorMap = getUnifiedColorMap(columnDataColors.userDefined, columnDataColors.systemDefined);
            updatedColorItems.forEach(colorItem => {
                const filteredColor = colorMap.filter(colorMapItem => colorMapItem.serieName !==
                    colorItem.serieName.toLowerCase());
                const chartConfigOptions = configOptions(chartModel.config.chartType, chartModel);
                let color = colorItem.color;
                if (chartConfigOptions.useAlphaColors) {
                    color = addAlphaToColor(colorItem.color);
                }
                colorMap = [
                    ...filteredColor,
                    {
                        color,
                        serieName: colorItem.serieName.toLowerCase(),
                    },
                ];
            });
            return {
                userDefined: colorMap,
                systemDefined: columnDataColors.systemDefined,
            };
        },
        isHiddenCallback: shouldHideColumnDataColorsPicker,
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.COLOR_CHANGE,
            };
        },
        ...options,
    };
};
export const createGeoAreaColorPicker = (options = {}) => {
    return {
        elementType: ChartSettingsElementType.CHART_DATA_COLOR_PICKER,
        key: 'multiColorSeriesColor',
        runTimeProperties: {
            colorItems: 'CUSTOM',
        },
        properties: {
            isMultiColorSeries: true,
            colorItems: [],
        },
        getRunTimeProperties: {
            colorItems: ({ currentProperties: multiSeriesColors = {
                userDefined: [],
                systemDefined: [],
            }, chartModel, dataModel, }) => {
                if (!dataModel)
                    return null;
                if (!multiSeriesColors.userDefined) {
                    return [];
                }
                const legendDataValues = getLegendDataValues(chartModel, dataModel);
                const multiColorSeriesMap = getUnifiedMultiColorSeriesColors(multiSeriesColors.userDefined, multiSeriesColors.systemDefined);
                const colorMap = [];
                legendDataValues.forEach(legend => {
                    const serieId = getSerie(dataModel, legend.label)
                        .blinkSeriesId;
                    const colorScale = getColorScaleOfMultiColorSeriesColors(multiColorSeriesMap, serieId, getXAxisColumnsHash(chartModel));
                    if (colorScale && colorScale.length > 0) {
                        colorMap.push({
                            color: colorScale[Math.floor(colorScale.length / 2)],
                            serieName: serieId,
                        });
                    }
                });
                return getDataWithColor(legendDataValues, colorMap);
            },
        },
        parseValueFromComponent: (updatedColorItems, multiColorSeries, chartModel) => {
            let updatedMultiColorSeries = multiColorSeries.userDefined;
            updatedColorItems.forEach(colorItem => {
                updatedMultiColorSeries = setColorScaleOfMultiColorSeriesColors(updatedMultiColorSeries, colorItem.serieName, getXAxisColumnsHash(chartModel), getScaleFromColor(colorItem === null || colorItem === void 0 ? void 0 : colorItem.color));
            });
            return {
                userDefined: updatedMultiColorSeries,
                systemDefined: multiColorSeries.systemDefined,
            };
        },
        isHiddenCallback: shouldHideColumnDataColorsPicker,
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.COLOR_CHANGE,
            };
        },
        ...options,
    };
};
export const createCommonConditionalFormatter = (options = {}) => {
    const defaultOptions = {
        key: options.key || 'conditionalFormatter',
        clientStatePath: options.clientStatePath || '',
        elementType: ChartSettingsElementType.CONDITIONAL_FORMATTER,
        properties: options.properties || {},
        value: options.value || null,
        label: options.label,
        children: options.children,
        isDisable: options.isDisable,
        isAdvanced: options.isAdvanced,
        canHaveAutoValue: options.canHaveAutoValue,
        visibleWhen: options.visibleWhen,
        helperText: options.helperText,
        onChange: options.onChange,
        link: options.link,
        isAnswerProperty: options.isAnswerProperty,
        hideScenarios: options.hideScenarios,
        runTimeProperties: options.runTimeProperties,
        fallbackPropertySelector: options.fallbackPropertySelector,
        parseValueToComponent: options.parseValueToComponent,
        parseValueFromComponent: options.parseValueFromComponent,
        isDisabledCallback: options.isDisabledCallback,
        addPaddingTop: options.addPaddingTop,
        addMarginBottom: options.addMarginBottom,
        isHiddenCallback: options.isHiddenCallback,
    };
    return createConditionalFormatter(defaultOptions);
};
export const createChartConditionalFormatter = (options = {}) => {
    return createCommonConditionalFormatter({
        properties: {
            vizType: 'ChartViz',
        },
        ...options,
    });
};
export const createTableConditionalFormatter = (options = {}) => {
    return createCommonConditionalFormatter({
        properties: {
            vizType: 'TableViz',
        },
        ...options,
    });
};
export const createHeadlineConditionalFormatter = () => {
    return createCommonConditionalFormatter({
        properties: {
            vizType: 'HeadlineViz',
        },
        isHiddenCallback: shouldHideTableSummarySettings,
    });
};
export const createHideNullValuesCheckbox = () => {
    return createCheckbox({
        key: 'excludeNullValues',
        properties: {
            label: 'charts.chartEditor.EXCLUDE_NULL_VALUES',
            value: true,
        },
        isHiddenCallback: shouldHideExcludeNullValuesCheckbox,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.CHANGE_EXCLUDE_NULL_VALUES,
                properties: {
                    enabled: updatedValue,
                },
            };
        },
    });
};
export const createLineSeriesFormatter = () => {
    return createLineFormatter({
        key: 'lineStyle',
        properties: {
            includeColorOption: false,
        },
        isHiddenCallback: shouldHideLineSeriesSettings,
        isAdvanced: true,
        getMixpanelConfig: ({ updatedValue, previousValue }) => {
            return getMixpanelConfigForLineStyle(updatedValue, previousValue, userActionTypes.CHANGE_LINE_TYPE.actionParams.source.COLUMN, false);
        },
    });
};
export const createLineMarkerVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'enableMarkers',
        properties: {
            label: 'SHOW_MARKER_ALL_THE_TIME',
        },
        isHiddenCallback: shouldHideLineSeriesSettings,
        isAdvanced: true,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_MARKERS,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createLineMarkerFormatter = () => {
    return createLabelledView({
        properties: {
            label: 'markerFormatter.markerType',
            childrenSize: 'large',
        },
        children: [
            createDropdown({
                key: 'markerStyle',
                properties: {
                    optionsGroups: [
                        {
                            options: [
                                {
                                    id: 'circle',
                                    label: 'markerFormatter.shape.circle',
                                    iconName: IconID.MARKER_CIRCLE,
                                },
                                {
                                    id: 'square',
                                    label: 'markerFormatter.shape.square',
                                    iconName: IconID.MARKER_SQUARE,
                                },
                                {
                                    id: 'triangle',
                                    label: 'markerFormatter.shape.triangle',
                                    iconName: IconID.MARKER_TRIANGLE,
                                },
                                {
                                    id: 'diamond',
                                    label: 'markerFormatter.shape.diamond',
                                    iconName: IconID.MARKER_DIAMOND,
                                },
                                {
                                    id: 'triangle-down',
                                    label: 'markerFormatter.shape.triangleDown',
                                    iconName: IconID.MARKER_TRIANGLE_DOWN,
                                },
                            ],
                        },
                    ],
                    value: { type: 'circle' },
                },
                parseValueFromComponent: value => {
                    return { type: value };
                },
                parseValueToComponent: ({ value }) => {
                    return value === null || value === void 0 ? void 0 : value.type;
                },
                translate: ['optionsGroups.options.label'],
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_MARKER_TYPE,
                        properties: {
                            markerType: updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.type,
                        },
                    };
                },
            }),
        ],
        isHiddenCallback: shouldHideLineSeriesSettings,
        isAdvanced: true,
        translate: ['label'],
    });
};
export const createAxisVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'visible',
        properties: {
            label: 'DISPLAY_ON_CHART',
            value: true,
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue, config, vizModel }) => {
            var _a;
            const { axisId } = config.metadata;
            const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_AXIS,
                properties: { enabled: updatedValue, axis: axisType },
            };
        },
    });
};
export const createAxisNameVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'isNameVisible',
        properties: {
            label: 'DISPLAY_ON_CHART',
            value: true,
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue, config, vizModel }) => {
            var _a;
            const { axisId } = config.metadata;
            const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_AXIS_NAME,
                properties: { enabled: updatedValue, axis: axisType },
            };
        },
    });
};
export const createAxisNameTextInput = () => {
    return createAxisRenameInput({
        isHiddenCallback: shouldHideAxisNameSettings,
    });
};
export const createAxisNameFontFormatter = () => {
    const extendedPaletteColors = getExtendedChartColorPalette();
    return createInheritanceWidget({
        key: 'nameTextStyle',
        isAdvanced: true,
        runTimeProperties: {
            linkedTo: 'CUSTOM',
        },
        getRunTimeProperties: {
            linkedTo: ({ chartModel }) => {
                const firstAxis = getFirstAxis(chartModel);
                return {
                    type: 'AXIS',
                    id: firstAxis.id,
                    key: 'nameTextStyle',
                };
            },
        },
        properties: {
            headingIconId: IconID.TEXT_STYLE,
            title: {
                linked: 'inheritance.SAME_AS_FIRST_AXIS',
                unlinked: 'inheritance.TEXT_STYLING',
            },
            tooltip: {
                linked: 'inheritance.UNLINK',
                unlinked: 'inheritance.LINK_TO_FIRST_AXIS',
            },
            ariaLabel: 'inheritance-widget',
            value: {
                isLinked: true,
            },
        },
        children: [
            createFontFormatter({
                key: 'nameTextStyle',
                properties: {
                    colorProps: {
                        colors: extendedPaletteColors,
                        viewType: PICKER_VIEW.EXTENDED,
                    },
                },
            }),
        ],
        isDisabledCallback: shouldDisableInheritanceForAxis,
        isHiddenCallback: shouldHideAxisNameSettings,
        translate: [
            'title.linked',
            'title.unlinked',
            'tooltip.linked',
            'tooltip.unlinked',
        ],
        getMixpanelConfig: ({ updatedValue, previousValue, config, vizModel, }) => {
            var _a;
            const { axisId } = config.metadata;
            const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
            const mixpanelConfig = getMixpanelConfigForFontStyle(updatedValue, previousValue, userActionTypes.CHANGE_TEXT_SIZE.actionParams.source.AXIS_NAME);
            return {
                ...mixpanelConfig,
                properties: {
                    ...mixpanelConfig.properties,
                    axisType,
                },
            };
        },
    });
};
export const createAxisValueLabelVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'isLabelVisible',
        properties: {
            label: 'DISPLAY_ON_CHART',
            value: true,
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue, config, vizModel }) => {
            var _a;
            const { axisId } = config.metadata;
            const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_AXIS_LABELS,
                properties: {
                    enabled: updatedValue,
                    axis: axisType,
                },
            };
        },
    });
};
export const createAxisValueLabelFontFormatter = () => {
    const extendedPaletteColors = getExtendedChartColorPalette();
    return createInheritanceWidget({
        key: 'labelTextStyle',
        isAdvanced: true,
        runTimeProperties: {
            linkedTo: 'CUSTOM',
        },
        getRunTimeProperties: {
            linkedTo: ({ chartModel }) => {
                const firstAxis = getFirstAxis(chartModel);
                return {
                    type: 'AXIS',
                    id: firstAxis.id,
                    key: 'labelTextStyle',
                };
            },
        },
        properties: {
            headingIconId: IconID.TEXT_STYLE,
            title: {
                linked: 'inheritance.SAME_AS_FIRST_AXIS',
                unlinked: 'inheritance.TEXT_STYLING',
            },
            tooltip: {
                linked: 'inheritance.UNLINK',
                unlinked: 'inheritance.LINK_TO_FIRST_AXIS',
            },
            ariaLabel: 'inheritance-widget',
            value: {
                isLinked: true,
            },
        },
        children: [
            createFontFormatter({
                key: 'labelTextStyle',
                properties: {
                    styleProps: {
                        visibleItems: [
                            FontItemID.BOLD,
                            FontItemID.ITALIC,
                            FontItemID.UNDERLINE,
                            FontItemID.WRAP,
                        ],
                    },
                    colorProps: {
                        colors: extendedPaletteColors,
                        viewType: PICKER_VIEW.EXTENDED,
                    },
                },
                parseValueToComponent: ({ value }) => {
                    return {
                        ...value,
                        color: (value === null || value === void 0 ? void 0 : value.color) || '#000000',
                    };
                },
            }),
        ],
        isDisabledCallback: shouldDisableInheritanceForAxis,
        isHiddenCallback: shouldHideAxisValueLabelSettings,
        translate: [
            'title.linked',
            'title.unlinked',
            'tooltip.linked',
            'tooltip.unlinked',
        ],
        getMixpanelConfig: ({ updatedValue, previousValue, config, vizModel, }) => {
            var _a;
            const { axisId } = config.metadata;
            const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
            const mixpanelConfig = getMixpanelConfigForFontStyle(updatedValue, previousValue, userActionTypes.CHANGE_TEXT_SIZE.actionParams.source
                .AXIS_VALUE_LABEL);
            return {
                ...mixpanelConfig,
                properties: {
                    ...mixpanelConfig.properties,
                    axisType,
                },
            };
        },
    });
};
export const createAxisValueLabelNumberFormatter = () => {
    return createInheritanceWidget({
        key: 'inheritNF',
        properties: {
            headingIconId: IconID.NUMBER_FORMAT,
            title: {
                linked: 'inheritance.SAME_AS_COLUMN',
                unlinked: 'numberFormat.FORMAT_LABEL',
            },
            tooltip: {
                linked: 'inheritance.UNLINK',
                unlinked: 'inheritance.LINK_TO_COLUMN',
            },
            ariaLabel: 'number-format-inheritance-widget',
            value: {
                isLinked: true,
            },
        },
        children: [
            createNumberFormatter({
                key: 'format',
                properties: {
                    variant: 'font',
                    typeProps: {
                        ariaLabel: 'number-type',
                    },
                    subTypeProps: {
                        ariaLabel: 'number-subtype',
                    },
                    formatProps: {
                        ariaLabel: 'number-format',
                    },
                },
                runTimeProperties: {
                    customFormatPattern: 'TS_INPUT',
                },
                parseValueToComponent: ({ chartModel, column }) => {
                    const axis = getAxisForColumn(chartModel, column.id);
                    const formatConfig = getFormattingForAxis(chartModel, axis.id);
                    if (isGrowth(column) &&
                        !formatConfig.numberFormatConfig &&
                        !formatConfig.currencyFormatConfig) {
                        return {
                            ...formatConfig,
                            numberFormatConfig: null,
                            currencyFormatConfig: null,
                        };
                    }
                    return formatConfig;
                },
                parseValueFromComponent: formtConfig => {
                    return getUpdatedFormatConfig(formtConfig);
                },
                isHiddenCallback: shouldHideAxisValueLabelNumberFormatter,
                getMixpanelConfig: ({ updatedValue, previousValue }) => {
                    return getNumberFormatMixPanelConfig(updatedValue, previousValue, userActionTypes.NUMBER_FORMAT.actionParams.target.AXIS);
                },
            }),
        ],
        translate: [
            'title.linked',
            'title.unlinked',
            'tooltip.linked',
            'tooltip.unlinked',
        ],
    });
};
export const createAxisValueLabelMaxCharactersInput = () => {
    return createLabelledView({
        properties: {
            label: 'LABEL_LENGTH',
        },
        isAdvanced: true,
        children: [
            createNumberInput({
                key: 'labelMaxCharacters',
                label: 'LABEL_LENGTH',
                properties: {
                    placeholder: 'Auto',
                    min: 1,
                    parser: (v) => v.replace(/[^0-9]/g, ''),
                },
                translate: ['label'],
                getMixpanelConfig: ({ updatedValue, config, vizModel }) => {
                    var _a;
                    const { axisId } = config.metadata;
                    const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
                    return {
                        eventName: userActionTypeEnum.CHANGE_MAX_LABEL_LENGTH,
                        properties: {
                            length: updatedValue,
                            source: userActionTypes.CHANGE_MAX_LABEL_LENGTH
                                .actionParams.source.AXIS_LABEL,
                            axis: axisType,
                        },
                    };
                },
            }),
        ],
        isHiddenCallback: shouldHideAxisValueLabelSettings,
        translate: ['label'],
    });
};
export const createAxisIntervalsVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'intervals.visible',
        properties: {
            label: 'DISPLAY_ON_CHART',
            value: false,
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue, config, vizModel }) => {
            var _a;
            const { axisId } = config.metadata;
            const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
            return {
                eventName: userActionTypeEnum.TOGGLE_INTERVALS,
                properties: { enabled: updatedValue, axis: axisType },
            };
        },
    });
};
export const createAxisIntervalsFormatter = () => {
    return createIntervalFormatter();
};
export const createAxisGridlinesVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'isGridLineEnabled',
        properties: {
            label: 'DISPLAY_GRIDLINE_ON_CHART',
        },
        parseValueToComponent: ({ chartModel, column, value }) => {
            if (_.isNil(value)) {
                const enableGridline = enableGridlines();
                const gridLinesConfig = getGridLinesConfig(chartModel, enableGridline);
                const axis = getAxisForColumn(chartModel, column.id);
                return axis.properties.axisType === AxisTypes.X
                    ? gridLinesConfig.xGridlineEnabled
                    : gridLinesConfig.yGridlineEnabled;
            }
            return value;
        },
        isDisabledCallback: shouldDisableGridlineCheckbox,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue, config, vizModel }) => {
            var _a;
            const { axisId } = config.metadata;
            const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
            return {
                eventName: userActionTypeEnum.TOGGLE_GRIDLINES,
                properties: { enabled: updatedValue, axis: axisType },
            };
        },
    });
};
export const createAxisGridlinesFormatter = () => {
    const extendedPaletteColors = getExtendedChartColorPalette();
    return createLineFormatter({
        key: 'gridlineStyle',
        properties: {
            value: {
                dashStyle: 'SOLID_LINE',
                color: '#E6E6E6',
                thickness: 1,
            },
            colorProps: {
                colors: extendedPaletteColors,
                viewType: PICKER_VIEW.EXTENDED,
            },
        },
        isHiddenCallback: shouldHideGridLineFromatter,
        getMixpanelConfig: ({ updatedValue, previousValue, config, vizModel, }) => {
            var _a;
            const { axisId } = config.metadata;
            const axisType = (_a = getAxisPropertiesById(vizModel.vizProp, axisId)) === null || _a === void 0 ? void 0 : _a.axisType;
            const mixpanelConfig = getMixpanelConfigForLineStyle(updatedValue, previousValue, userActionTypes.CHANGE_LINE_TYPE.actionParams.source
                .AXIS_GRIDLINE);
            return {
                ...mixpanelConfig,
                properties: {
                    ...mixpanelConfig.properties,
                    axisType,
                },
            };
        },
    });
};
export const createAxisVerticalPositionControl = () => {
    return createPositionControl({
        key: 'position',
        parseValueToComponent: ({ value }) => {
            return value ? VerticalDirection.Top : VerticalDirection.Bottom;
        },
        parseValueFromComponent: activeState => {
            return activeState === VerticalDirection.Top;
        },
        properties: {
            label: 'Position',
            childrenSize: 'medium',
            variant: DirectionType.Vertical,
        },
        isHiddenCallback: shouldHideAxisSettings,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.POSITION_AXIS,
                properties: {
                    source: userActionTypes.POSITION_AXIS.actionParams.source
                        .CONFIG_PANEL,
                    positionType: updatedValue
                        ? VerticalDirection.Top
                        : VerticalDirection.Bottom,
                },
            };
        },
    });
};
export const createAxisHorizontalPositionControl = () => {
    return createPositionControl({
        key: 'position',
        parseValueToComponent: ({ value }) => {
            return value ? HorizontalDirection.Right : HorizontalDirection.Left;
        },
        parseValueFromComponent: activeState => {
            return activeState === HorizontalDirection.Right;
        },
        properties: {
            label: 'Position',
            childrenSize: 'medium',
            variant: DirectionType.Horizontal,
        },
        isHiddenCallback: (props) => shouldHideAxisSettings(props) ||
            shouldHideAxisHorizontalPositionControl(props),
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.POSITION_AXIS,
                properties: {
                    source: userActionTypes.POSITION_AXIS.actionParams.source
                        .CONFIG_PANEL,
                    positionType: updatedValue
                        ? HorizontalDirection.Right
                        : HorizontalDirection.Left,
                },
            };
        },
    });
};
export const createYAxisNumberRangeInput = () => {
    return createNumberRange({
        key: 'yAxisRange',
        isAdvanced: true,
        isHiddenCallback: shouldHideAxisSettings,
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.CHANGE_AXIS_RANGE,
            };
        },
    });
};
export const createAllDataLabelVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'allLabels',
        properties: {
            label: 'DISPLAY_ALL_LABELS',
        },
        parseValueToComponent: ({ chartModel, value }) => {
            var _a;
            const chartType = getChartType(chartModel);
            const options = configOptions(chartType, chartModel);
            if (_.isNil(value)) {
                return (_a = options === null || options === void 0 ? void 0 : options.dataLabelsEnabledByDefault) !== null && _a !== void 0 ? _a : false;
            }
            return value;
        },
        updateCascadedValues: (value, clientState) => {
            return {
                ...clientState,
                dataLabelProperties: Object.fromEntries(Object.entries(clientState.dataLabelProperties).map(([columnId, column]) => [
                    columnId,
                    column && typeof column === 'object'
                        ? { ...column, isVisible: value }
                        : column,
                ])),
            };
        },
        isDisabledCallback: shouldDisableDataLabelsVisibilityCheckbox,
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_ALL_DATA_LABELS,
                properties: { enabled: updatedValue },
            };
        },
        translate: ['label'],
    });
};
export const createAllDataLabelVisibilityCheckboxForHeatmapChart = () => {
    return createCheckbox({
        key: 'isVisible',
        properties: {
            label: 'DISPLAY_ON_CHART',
        },
        parseValueToComponent: ({ value }) => {
            if (_.isNil(value)) {
                return true;
            }
            return value;
        },
        updateCascadedValues: (value, clientState) => {
            return {
                ...clientState,
                dataLabelProperties: Object.fromEntries(Object.entries(clientState.dataLabelProperties).map(([columnId, column]) => [
                    columnId,
                    column && typeof column === 'object'
                        ? { ...column, isVisible: value }
                        : column,
                ])),
            };
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_DATA_LABELS,
                properties: { enabled: updatedValue },
            };
        },
        isDisabledCallback: shouldDisableDataLabelsVisibilityCheckbox,
        translate: ['label'],
    });
};
export const createAllDataLabelVisibilityCheckboxForTreemapChart = () => {
    return createCheckbox({
        key: 'isVisible',
        properties: {
            label: 'DISPLAY_ON_CHART',
        },
        parseValueToComponent: ({ value }) => {
            if (_.isNil(value)) {
                return true;
            }
            return value;
        },
        updateCascadedValues: (value, clientState) => {
            return updateDataLabelProperties(value, clientState);
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_DATA_LABELS,
                properties: { enabled: updatedValue },
            };
        },
        translate: ['label'],
    });
};
export const createAllDataLabelVisibilityCheckboxForStackedCharts = () => {
    return createCheckbox({
        key: 'allLabels',
        properties: {
            label: 'DISPLAY_ALL_LABELS',
            value: false,
        },
        updateCascadedValues: (value, clientState) => {
            return {
                ...clientState,
                dataLabelProperties: {
                    ...Object.fromEntries(Object.entries(clientState.dataLabelProperties).map(([columnId, column]) => [
                        columnId,
                        column && typeof column === 'object'
                            ? { ...column, isVisible: value }
                            : column,
                    ])),
                    showStackedLabels: value,
                },
            };
        },
        translate: ['label'],
        isDisabledCallback: shouldDisableTotalLabelsCheckbox,
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_ALL_DATA_LABELS,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createDataLabelVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'isVisible',
        properties: {
            label: 'DISPLAY_ON_CHART',
        },
        parseValueToComponent: ({ chartModel, value }) => {
            var _a;
            if (!_.isNil(value)) {
                return value;
            }
            const chartType = getChartType(chartModel);
            const options = configOptions(chartType, chartModel);
            return (_a = options === null || options === void 0 ? void 0 : options.dataLabelsEnabledByDefault) !== null && _a !== void 0 ? _a : false;
        },
        updateCascadedValues: (value, clientState, chartModel) => {
            var _a;
            if (!value) {
                return {
                    ...clientState,
                    dataLabelProperties: {
                        ...clientState.dataLabelProperties,
                        allLabels: false,
                    },
                };
            }
            const columns = getVisualizedMeasureColumns(chartModel);
            const chartType = getChartType(chartModel);
            const options = configOptions(chartType, chartModel);
            const defaultDataLabelsEnabled = (_a = options === null || options === void 0 ? void 0 : options.dataLabelsEnabledByDefault) !== null && _a !== void 0 ? _a : false;
            const allLabelsEnabled = columns.every(column => {
                var _a;
                const isVisible = (_a = clientState.dataLabelProperties[column.id]) === null || _a === void 0 ? void 0 : _a.isVisible;
                return _.isNil(isVisible)
                    ? defaultDataLabelsEnabled
                    : isVisible;
            });
            return {
                ...clientState,
                dataLabelProperties: {
                    ...clientState.dataLabelProperties,
                    allLabels: allLabelsEnabled,
                },
            };
        },
        isDisabledCallback: shouldDisableDataLabelsVisibilityCheckbox,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_DATA_LABELS,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createDataLabelFontFormatter = () => {
    const extendedPaletteColors = getExtendedChartColorPalette();
    return createInheritanceWidget({
        key: 'labelTextStyle',
        isAdvanced: true,
        runTimeProperties: {
            linkedTo: 'CUSTOM',
        },
        getRunTimeProperties: {
            linkedTo: ({ chartModel }) => {
                const firstColumnId = getSortedColumnsIdOfType(chartModel, 'Y')[0];
                return {
                    type: 'DATA_LABEL_PROPS',
                    id: firstColumnId,
                    key: 'labelTextStyle',
                };
            },
        },
        properties: {
            headingIconId: IconID.TEXT_STYLE,
            title: {
                linked: 'inheritance.SAME_AS_FIRST_COLUMN',
                unlinked: 'inheritance.TEXT_STYLING',
            },
            tooltip: {
                linked: 'inheritance.UNLINK',
                unlinked: 'inheritance.LINK_TO_FIRST_COLUMN',
            },
            ariaLabel: 'inheritance-widget',
            value: {
                isLinked: true,
            },
        },
        children: [
            createFontFormatter({
                key: 'labelTextStyle',
                properties: {
                    colorProps: {
                        showEmptyColor: true,
                        colors: extendedPaletteColors,
                        viewType: PICKER_VIEW.EXTENDED,
                    },
                },
            }),
        ],
        isDisabledCallback: shouldDisableInheritanceForDataLabel,
        isHiddenCallback: shouldHideDataLabelSettings,
        translate: [
            'title.linked',
            'title.unlinked',
            'tooltip.linked',
            'tooltip.unlinked',
        ],
        getMixpanelConfig: ({ updatedValue, previousValue }) => {
            return getMixpanelConfigForFontStyle(updatedValue, previousValue, userActionTypes.CHANGE_TEXT_SIZE.actionParams.source.DATA_LABEL);
        },
    });
};
export const createDataLabelMaxLengthInput = () => {
    return createLabelledView({
        properties: {
            label: 'LABEL_LENGTH',
        },
        children: [
            createNumberInput({
                key: 'maxCharacters',
                properties: {
                    placeholder: 'Auto',
                    min: 1,
                    max: 20,
                    parser: (v) => v.replace(/[^0-9]/g, ''),
                },
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_MAX_LABEL_LENGTH,
                        properties: {
                            length: updatedValue,
                            source: userActionTypes.CHANGE_MAX_LABEL_LENGTH
                                .actionParams.source.DATA_LABEL,
                        },
                    };
                },
            }),
        ],
        isAdvanced: true,
        isHiddenCallback: shouldHideDataLabelSettings,
        translate: ['label'],
    });
};
export const createDataLabelAlignmentDropdown = () => {
    return createLabelledView({
        properties: {
            label: 'ALIGNMENT',
        },
        children: [
            createDropdown({
                key: 'align',
                properties: {
                    optionsGroups: [
                        {
                            options: [
                                {
                                    id: 'left',
                                    label: 'Left',
                                },
                                {
                                    id: 'center',
                                    label: 'Center',
                                },
                                {
                                    id: 'right',
                                    label: 'Right',
                                },
                            ],
                        },
                    ],
                    dropdownWidth: 'targetWidth',
                    value: 'center',
                },
                translate: ['optionsGroups.options.label'],
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_DATA_LABEL_ALIGNMENT,
                        properties: {
                            alignmentType: updatedValue,
                        },
                    };
                },
            }),
        ],
        isAdvanced: true,
        isHiddenCallback: shouldHideDataLabelSettings,
        translate: ['label'],
    });
};
export const createDataLabelBackgroundFormatter = () => {
    return createLabelledView({
        properties: {
            label: 'BACKGROUND',
            orientation: 'Vertical',
        },
        isAdvanced: true,
        children: [
            createBackgroundFormatter({
                key: 'backgroundStyle',
                properties: {
                    backgroundOpacityProps: {
                        visible: false,
                    },
                },
                getMixpanelConfig: ({ updatedValue, previousValue }) => {
                    return getMixpanelConfigForBackgroundStyle(updatedValue, previousValue, userActionTypes.CHANGE_BACKGROUND_COLOR.actionParams
                        .source.DATA_LABEL);
                },
            }),
        ],
        isHiddenCallback: shouldHideDataLabelSettings,
        translate: ['label'],
    });
};
export const createDataLabelFilterDropdown = () => {
    return createLabelledView({
        isAdvanced: true,
        properties: {
            label: 'FILTER_VALUES',
        },
        children: [
            createDropdown({
                key: 'filter',
                properties: {
                    optionsGroups: [
                        {
                            options: [
                                {
                                    id: 'showAll',
                                    label: 'SHOW_ALL',
                                },
                                {
                                    id: 'custom',
                                    label: 'CUSTOM',
                                },
                            ],
                        },
                    ],
                    dropdownWidth: 'targetWidth',
                },
                parseValueToComponent: ({ value }) => {
                    return value ? 'custom' : 'showAll';
                },
                parseValueFromComponent: value => {
                    if (value === 'showAll')
                        return null;
                    return { value: 0, operator: 'Greater than or equal to' };
                },
                translate: ['optionsGroups.options.label'],
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.FILTER_DATA_LABELS,
                        properties: {
                            filterType: updatedValue == null
                                ? userActionTypes.FILTER_DATA_LABELS
                                    .actionParams.filterType.SHOW_ALL
                                : userActionTypes.FILTER_DATA_LABELS
                                    .actionParams.filterType.CUSTOM,
                        },
                    };
                },
            }),
        ],
        isHiddenCallback: shouldHideDataLabelSettings,
        translate: ['label'],
    });
};
export const createDataLabelNumericFilter = () => {
    return createNumericFilterInput({
        isAdvanced: true,
        key: 'filter',
        isHiddenCallback: (props) => {
            return (shouldHideDataLabelSettings(props) ||
                shouldHideDataLabelNumericFilter(props));
        },
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.FILTER_DATA_LABELS,
                properties: {
                    filterType: userActionTypes.FILTER_DATA_LABELS.actionParams
                        .filterType.CUSTOM,
                },
            };
        },
    });
};
export const createStackLabelFontFormatter = () => {
    return createFontFormatter({
        key: 'stackLabels.labelTextStyle',
        isAdvanced: true,
        properties: {
            colorProps: {
                showEmptyColor: true,
            },
        },
        isHiddenCallback: shouldHideStackLabelAdvancedSettings,
    });
};
export const createStackLabelMaxLengthInput = () => {
    return createLabelledView({
        properties: {
            label: 'LABEL_LENGTH',
        },
        children: [
            createNumberInput({
                key: 'stackLabels.maxCharacters',
                properties: {
                    placeholder: 'Auto',
                    min: 1,
                    max: 20,
                    parser: (v) => v.replace(/[^0-9]/g, ''),
                },
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_MAX_LABEL_LENGTH,
                        properties: {
                            length: updatedValue,
                            source: userActionTypes.CHANGE_MAX_LABEL_LENGTH
                                .actionParams.source.DATA_LABEL,
                        },
                    };
                },
            }),
        ],
        isAdvanced: true,
        isHiddenCallback: shouldHideStackLabelAdvancedSettings,
        translate: ['label'],
    });
};
export const createStackLabelBackgroundFormatter = () => {
    return createLabelledView({
        properties: {
            label: 'BACKGROUND',
            orientation: 'Vertical',
        },
        isAdvanced: true,
        children: [
            createBackgroundFormatter({
                key: 'stackLabels.backgroundStyle',
                properties: {
                    backgroundOpacityProps: {
                        visible: false,
                    },
                },
                getMixpanelConfig: ({ updatedValue, previousValue }) => {
                    return getMixpanelConfigForBackgroundStyle(updatedValue, previousValue, userActionTypes.CHANGE_BACKGROUND_COLOR.actionParams
                        .source.DATA_LABEL);
                },
            }),
        ],
        isHiddenCallback: shouldHideStackLabelAdvancedSettings,
        translate: ['label'],
    });
};
export const createTooltipVisibilityCheckbox = () => {
    return createCheckbox({
        key: 'isVisible',
        properties: {
            label: 'DISPLAY_ON_CHART',
        },
        translate: ['label'],
        isDisabledCallback: shouldDisableTooltipVisibilityCheckbox,
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_TOOLTIP,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createTooltipContentFormatter = () => {
    return createLabelledView({
        properties: {
            label: 'CONTENT',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createElement(ChartSettingsElementType.TOOLTIP_CONFIGURATOR, {
                key: 'tooltip-accordion-item',
            }),
        ],
        translate: ['label'],
    });
};
export const createTooltipBackgroundFormatter = () => {
    const extendedPaletteColors = getExtendedChartColorPalette();
    return createLabelledView({
        properties: {
            label: 'BACKGROUND',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createBackgroundFormatter({
                key: 'backgroundStyle',
                properties: {
                    value: {
                        backgroundColor: '#323946',
                        borderColor: '#323946',
                        backgroundOpacity: 90,
                    },
                    borderColorProps: {
                        showEmptyColor: false,
                        colors: extendedPaletteColors,
                        viewType: PICKER_VIEW.EXTENDED,
                    },
                    backgroundColorProps: {
                        showEmptyColor: false,
                        colors: extendedPaletteColors,
                        viewType: PICKER_VIEW.EXTENDED,
                    },
                },
                getMixpanelConfig: ({ updatedValue, previousValue }) => {
                    return getMixpanelConfigForBackgroundStyle(updatedValue, previousValue, userActionTypes.CHANGE_BACKGROUND_COLOR.actionParams
                        .source.TOOLTIP);
                },
            }),
        ],
        translate: ['label'],
    });
};
export const createTooltipFieldLabelFormatter = () => {
    const extendedPaletteColors = getExtendedChartColorPalette();
    return createLabelledView({
        properties: {
            label: 'FIELD_LABEL',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createFontFormatter({
                key: 'labelTextStyle',
                properties: {
                    value: {
                        size: '12',
                        color: '#FFFFFF',
                    },
                    colorProps: {
                        colors: extendedPaletteColors,
                        viewType: PICKER_VIEW.EXTENDED,
                    },
                },
                getMixpanelConfig: ({ updatedValue, previousValue }) => {
                    return getMixpanelConfigForFontStyle(updatedValue, previousValue, userActionTypes.CHANGE_TEXT_SIZE.actionParams.source
                        .TOOLTIP_FIELD_LABEL);
                },
            }),
        ],
        translate: ['label'],
    });
};
export const createTooltipFontFormatter = () => {
    const extendedPaletteColors = getExtendedChartColorPalette();
    return createLabelledView({
        properties: {
            label: 'VALUE_LABEL',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createFontFormatter({
                key: 'valueTextStyle',
                properties: {
                    value: {
                        size: '12',
                        color: '#FFFFFF',
                    },
                    colorProps: {
                        colors: extendedPaletteColors,
                        viewType: PICKER_VIEW.EXTENDED,
                    },
                },
                getMixpanelConfig: ({ updatedValue, previousValue }) => {
                    return getMixpanelConfigForFontStyle(updatedValue, previousValue, userActionTypes.CHANGE_TEXT_SIZE.actionParams.source
                        .TOOLTIP_VALUE_LABEL);
                },
            }),
        ],
        translate: ['label'],
    });
};
export const createLegendEnabledCheckbox = (options = {}) => {
    return createCheckbox({
        key: 'enabled',
        addPaddingTop: true,
        addMarginBottom: true,
        runTimeProperties: {
            disabled: 'TS_INPUT',
        },
        isDisabledCallback: shouldDisableLegendCheckbox,
        properties: {
            label: 'DISPLAY_ON_CHART',
        },
        parseValueToComponent: ({ chart, chartModel, value }) => {
            const dataModel = chart.getDataModel();
            const isLegendDisabled = !!dataModel && getLegendCardinality(chartModel, dataModel) <= 1;
            return !isLegendDisabled && (_.isNil(value) || value);
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_LEGEND_VISIBILITY,
                properties: { enabled: updatedValue },
            };
        },
        ...options,
    });
};
export const createLegendPositionComponent = (properties = {}) => {
    return createPositionControl({
        key: 'position',
        properties: {
            label: 'Position',
            childrenSize: 'large',
            variant: DirectionType.Cardinal,
            value: HorizontalDirection.Right,
            ...properties,
        },
        runTimeProperties: {
            disabled: 'TS_INPUT',
        },
        isDisabledCallback: shouldDisableLegendPosition,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.CHANGE_LEGEND_POSITION,
                properties: { position: updatedValue },
            };
        },
    });
};
export const createResponsiveLayoutCheckbox = (options = {}) => {
    return createCheckbox({
        key: 'responsiveLayoutPreference',
        parseValueToComponent: ({ value }) => {
            switch (value) {
                case ChartResponsiveLayout.AutoOn:
                case ChartResponsiveLayout.UserPreferredOn:
                    return true;
                default:
                    return false;
            }
        },
        parseValueFromComponent: isChecked => {
            return isChecked
                ? ChartResponsiveLayout.UserPreferredOn
                : ChartResponsiveLayout.UserPreferredOff;
        },
        properties: {
            label: 'charts.chartEditor.RESPONSIVE_LAYOUT',
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_FIT_TO_SCREEN,
                properties: { enabled: updatedValue },
            };
        },
        ...options,
    });
};
export const createAutoSetBarWidthCheckbox = (options = {}) => {
    return createCheckbox({
        key: 'autoSetBarWidth',
        properties: {
            label: 'AUTO_SET_BAR_WIDTH',
        },
        isAdvanced: true,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_AUTO_SET_BAR_WIDTH,
                properties: { enabled: updatedValue },
            };
        },
        ...options,
    });
};
export const createBarWidthLabelledView = () => {
    const numberInput = createNumberInput({
        key: 'barWidth',
        properties: {
            placeholder: 'Auto',
            min: 1,
        },
        parseValueFromComponent: value => {
            return value.toString();
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.CHANGE_BAR_WIDTH,
                properties: {
                    barWidth: updatedValue,
                },
            };
        },
    });
    return createLabelledView({
        properties: {
            label: 'BAR_WIDTH',
            childrenSize: 'small',
        },
        children: [numberInput],
        isHiddenCallback: shouldHideBarWidthSettings,
        translate: ['label'],
    });
};
export const createBarPaddingLabelledView = () => {
    const numberInput = createNumberInput({
        key: 'barPadding',
        properties: {
            placeholder: 'Auto',
            min: 0,
            max: 1,
            step: 0.1,
        },
        parseValueFromComponent: value => {
            return value.toString();
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.CHANGE_BAR_PADDING,
                properties: {
                    barPadding: updatedValue,
                },
            };
        },
    });
    return createLabelledView({
        properties: {
            label: 'BAR_PADDING',
            childrenSize: 'small',
        },
        children: [numberInput],
        isHiddenCallback: shouldHideBarWidthSettings,
        translate: ['label'],
    });
};
export const createGroupPaddingLabelledView = () => {
    const numberInput = createNumberInput({
        key: 'groupPadding',
        properties: {
            placeholder: 'Auto',
            min: 0,
            max: 1,
            step: 0.1,
        },
        parseValueFromComponent: value => {
            return value.toString();
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.CHANGE_BAR_GROUP_PADDING,
                properties: {
                    groupPadding: updatedValue,
                },
            };
        },
    });
    return createLabelledView({
        properties: {
            label: 'GROUP_PADDING',
            childrenSize: 'small',
        },
        children: [numberInput],
        isHiddenCallback: shouldHideBarWidthSettings,
        translate: ['label'],
    });
};
export const createMaxDataPointsInput = (options = {}) => {
    return createElement(ChartSettingsElementType.MAX_DATA_POINTS_INPUT, {
        ...options,
    });
};
export const createPieBorderFormatter = () => {
    return createLineFormatter({
        key: 'borderStyle',
        properties: {
            includeStyleOption: false,
        },
        parseValueToComponent: ({ value }) => {
            var _a;
            const thickness = parseInt(value === null || value === void 0 ? void 0 : value.thickness, 10);
            return {
                thickness: Number.isNaN(thickness) ? 0 : thickness,
                color: (_a = value === null || value === void 0 ? void 0 : value.color) !== null && _a !== void 0 ? _a : '#FFFFFF',
            };
        },
        parseValueFromComponent: value => {
            return {
                thickness: value.thickness.toString(),
                color: value.color,
            };
        },
        getMixpanelConfig: ({ updatedValue, previousValue }) => {
            return getMixpanelConfigForBorderStyle(updatedValue, previousValue);
        },
        isAdvanced: true,
    });
};
export const createChartBackgroundColorFormatter = () => {
    return createLabelledView({
        properties: {
            label: 'CHART_BACKGROUND',
            orientation: 'Vertical',
        },
        children: [
            createBackgroundFormatter({
                key: 'chart.backgroundStyle',
                properties: {
                    backgroundOpacityProps: { visible: false },
                },
                getMixpanelConfig: ({ updatedValue, previousValue }) => {
                    return getMixpanelConfigForBackgroundStyle(updatedValue, previousValue, userActionTypes.CHANGE_BACKGROUND_COLOR.actionParams
                        .source.CHART_BACKGROUND);
                },
            }),
        ],
        translate: ['label'],
    });
};
export const createPlotAreaBackgroundColorFormatter = () => {
    return createLabelledView({
        properties: {
            label: 'PLOTTED_AREA_BACKGROUND',
            orientation: 'Vertical',
        },
        children: [
            createBackgroundFormatter({
                key: 'plotArea.backgroundStyle',
                properties: {
                    backgroundOpacityProps: { visible: false },
                },
                getMixpanelConfig: ({ updatedValue, previousValue }) => {
                    return getMixpanelConfigForBackgroundStyle(updatedValue, previousValue, userActionTypes.CHANGE_BACKGROUND_COLOR.actionParams
                        .source.PLOTTED_BACKGROUND);
                },
            }),
        ],
        translate: ['label'],
    });
};
export const createRegressionLineCheckbox = () => {
    var _a, _b, _c, _d;
    const allColors = (_d = (_c = (_b = (_a = getConfig()) === null || _a === void 0 ? void 0 : _a.getChartColorPalettes()) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.getColors()) !== null && _d !== void 0 ? _d : [];
    const defaultColor = getRandomColorFromPalette(allColors);
    return createCheckbox({
        key: 'regressionLine.enabled',
        properties: {
            label: 'DISPLAY_ON_CHART',
            value: false,
        },
        isAdvanced: true,
        translate: ['label'],
        updateCascadedValues: (value, clientState) => {
            var _a, _b, _c, _d, _e, _f;
            if (!value) {
                return clientState;
            }
            const existingColor = (_c = (_b = (_a = clientState === null || clientState === void 0 ? void 0 : clientState.displayProperties) === null || _a === void 0 ? void 0 : _a.regressionLine) === null || _b === void 0 ? void 0 : _b.lineStyle) === null || _c === void 0 ? void 0 : _c.color;
            if (existingColor) {
                return clientState;
            }
            return {
                ...clientState,
                displayProperties: {
                    ...clientState === null || clientState === void 0 ? void 0 : clientState.displayProperties,
                    regressionLine: {
                        ...(_d = clientState === null || clientState === void 0 ? void 0 : clientState.displayProperties) === null || _d === void 0 ? void 0 : _d.regressionLine,
                        lineStyle: {
                            ...(_f = (_e = clientState === null || clientState === void 0 ? void 0 : clientState.displayProperties) === null || _e === void 0 ? void 0 : _e.regressionLine) === null || _f === void 0 ? void 0 : _f.lineStyle,
                            color: defaultColor,
                        },
                    },
                },
            };
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_REGRESSION_LINE,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createRegressionLineFormatter = () => {
    var _a, _b, _c, _d;
    return createLineFormatter({
        key: 'regressionLine.lineStyle',
        label: 'DISPLAY_ON_CHART',
        value: false,
        isAdvanced: true,
        isHiddenCallback: shouldHideRegressionLineFromatter,
        translate: ['label'],
        properties: {
            colorProps: {
                colors: (_d = (_c = (_b = (_a = getConfig()) === null || _a === void 0 ? void 0 : _a.getChartColorPalettes()) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.getColors()) !== null && _d !== void 0 ? _d : [],
                viewType: PICKER_VIEW.LIMITED,
            },
        },
        getMixpanelConfig: ({ updatedValue, previousValue }) => {
            return getMixpanelConfigForLineStyle(updatedValue, previousValue, userActionTypes.CHANGE_LINE_TYPE.actionParams.source
                .REGRESSION_LINE);
        },
    });
};
export const createChartZoomComponent = () => {
    return createLabelledView({
        properties: {
            label: 'Zoom_into_chart',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createChartZoom({
                key: 'isZoomed',
            }),
        ],
        translate: ['label'],
    });
};
export const createShowTotalLabelsCheckbox = (options = {}) => {
    return createCheckbox({
        key: 'stackLabels.isVisible',
        elementType: ChartSettingsElementType.CHECKBOX,
        addPaddingTop: true,
        properties: {
            label: 'charts.chartEditor.SHOW_TOTAL_LABELS',
        },
        isDisabledCallback: shouldDisableTotalLabelsCheckbox,
        updateCascadedValues: (value, clientState, chartModel) => {
            if (!value) {
                return {
                    ...clientState,
                    dataLabelProperties: {
                        ...clientState.dataLabelProperties,
                        allLabels: false,
                    },
                };
            }
            const columns = getVisualizedMeasureColumns(chartModel);
            let allLabelsEnabled = !columns.some(column => {
                const columnProperties = clientState.dataLabelProperties[column.id];
                return (columnProperties === null || columnProperties === void 0 ? void 0 : columnProperties.isVisible) === false;
            });
            allLabelsEnabled =
                allLabelsEnabled &&
                    clientState.dataLabelProperties.stackLabels.isVisible;
            return {
                ...clientState,
                dataLabelProperties: {
                    ...clientState.dataLabelProperties,
                    allLabels: allLabelsEnabled,
                },
            };
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_TOTAL_LABELS,
                properties: { enabled: updatedValue },
            };
        },
        ...options,
    });
};
export const createStackedAsPercentCheckbox = (options = {}) => {
    return createCheckbox({
        key: 'isStackedAsPercent',
        elementType: ChartSettingsElementType.CHECKBOX,
        addPaddingTop: true,
        properties: {
            label: 'charts.chartEditor.SHOW_AXIS_AS_PERCENT',
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_Y_AXIS_AS_PERCENT,
                properties: { enabled: updatedValue },
            };
        },
        ...options,
    });
};
export const createStackedAsPercentNumberFormatter = (options = {}) => {
    return createNumberFormatter({
        key: 'stackedAsPercentFormat',
        properties: {
            typeProps: {
                ariaLabel: 'number-type',
                disabled: true,
            },
            subTypeProps: {
                disabled: false,
                ariaLabel: 'number-subtype',
            },
            formatProps: {
                ariaLabel: 'number-format',
            },
        },
        isHiddenCallback: shouldHideStackedAsPercentFormatter,
        parseValueFromComponent: formtConfig => {
            return getUpdatedFormatConfig(formtConfig);
        },
        getMixpanelConfig: ({ updatedValue }) => {
            var _a;
            return {
                eventName: userActionTypeEnum.CHANGE_STACK_PERCENTAGE_DISPLAY_FORMAT,
                properties: {
                    decimals: (_a = updatedValue.percentageFormatConfig) === null || _a === void 0 ? void 0 : _a.decimals,
                },
            };
        },
        ...options,
    });
};
export const createMarkerRadiusInput = () => {
    return createLabelledView({
        properties: {
            label: 'MARKER_RADIUS_LABEL)',
            childrenSize: 'small',
        },
        children: [
            createNumberInput({
                key: 'markerRadius',
            }),
        ],
        isAdvanced: true,
        translate: ['label'],
    });
};
export const createCandlestickColorPicker = (options = {}) => {
    return {
        elementType: ChartSettingsElementType.CHART_DATA_COLOR_PICKER,
        key: 'customColorSelectorArray',
        runTimeProperties: {
            colorItems: 'CUSTOM',
        },
        properties: {
            colorItems: [],
        },
        getRunTimeProperties: {
            colorItems: ({ currentProperties, }) => {
                return getCandleStickChartColorItems(currentProperties);
            },
        },
        parseValueFromComponent: (value, currentValue) => {
            const baseColors = _.isEmpty(currentValue) || currentValue.length === 0
                ? chartSpecificConstants.DEFAULT_CANDLESTICK_COLORS
                : currentValue;
            return [value[0].color, value[1].color, ...baseColors.slice(2)];
        },
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.COLOR_CHANGE,
            };
        },
        ...options,
    };
};
export const createShowConnectingLinesCheckbox = (options = {}) => {
    return createCheckbox({
        key: 'connectingLines',
        properties: {
            label: 'SHOW_CONNECTING_LINES',
        },
        isAdvanced: true,
        parseValueToComponent: ({ value }) => {
            return value ? !value : true;
        },
        parseValueFromComponent: isChecked => {
            return !isChecked;
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_CONNECTING_LINES,
                properties: { enabled: updatedValue },
            };
        },
        ...options,
    });
};
export const createParetoLineColorPicker = (options = {}) => {
    return createLabelledView({
        properties: {
            label: 'CUMULATIVE_PERCENTAGE',
            childrenSize: 'small',
        },
        children: [
            createColorPicker({
                key: 'lineColor',
                elementType: ChartSettingsElementType.COLOR_PICKER,
            }),
        ],
        isAdvanced: true,
        translate: ['label'],
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.COLOR_CHANGE,
            };
        },
        ...options,
    });
};
export const createBorderWidthInput = () => {
    return createLabelledView({
        properties: {
            label: 'backgroundFormatter.borderWidth',
        },
        children: [
            createNumberInput({
                key: 'borderStyle.thickness',
                properties: {
                    min: 0,
                },
                parseValueToComponent: ({ value }) => {
                    const thickness = parseInt(value, 10);
                    return Number.isNaN(thickness) ? 0 : thickness;
                },
                parseValueFromComponent: value => {
                    return value.toString();
                },
                getMixpanelConfig: () => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_BORDER_THICKNESS,
                    };
                },
            }),
        ],
        isAdvanced: true,
        translate: ['label'],
    });
};
export const createMapTileTypeDropdown = () => {
    return createLabelledView({
        properties: {
            label: 'MAP_TYPE',
            childrenSize: 'large',
        },
        children: [
            createDropdown({
                key: 'mapTileType',
                properties: {
                    optionsGroups: [
                        {
                            options: Object.keys(GEO_TILE_TYPES.MAPBOX).map(key => {
                                return {
                                    id: GEO_TILE_TYPES.MAPBOX[key],
                                    label: MAPBOX_TILE_LABELS[key],
                                };
                            }),
                        },
                    ],
                    dropdownWidth: 'targetWidth',
                    value: 'light-v9',
                },
                isDisabledCallback: shouldDisableMapTileDropdown,
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_MAP_TILE_TYPE,
                        properties: {
                            mapTileType: updatedValue,
                        },
                    };
                },
            }),
        ],
        translate: ['label'],
    });
};
export const createHeatmapModeCheckbox = (options = {}) => {
    return createCheckbox({
        key: 'isHeatmapOverlayed',
        properties: {
            label: 'charts.chartEditor.OVERLAY_HEATMAP',
        },
        isDisabledCallback: shouldDisableHeatmapModeCheckbox,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_OVERLAY_HEATMAP,
                properties: { enabled: updatedValue },
            };
        },
        ...options,
    });
};
export const createCompactHeadersCheckbox = (options = {}) => {
    return createCheckbox({
        key: 'useFlatLayout',
        properties: {
            label: 'COMPACT_HEADERS',
        },
        parseValueToComponent: ({ value, chartModel }) => {
            const axisConfig = getAxisConfig(chartModel);
            if (containsMeasureNamesOrMeasureValuesColumns(axisConfig) &&
                value === undefined) {
                return false;
            }
            return !value;
        },
        parseValueFromComponent: isChecked => {
            return !isChecked;
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_PIVOT_COMPACT_LAYOUT,
                properties: { enabled: updatedValue },
            };
        },
        ...options,
    });
};
export const createTotalsPositionRadioGroup = (options = {}) => {
    const radioGroup = createRadioGroup({
        key: 'showPivotSummaryPrior',
        properties: {
            id: 'format',
        },
        children: [
            createRadio({
                properties: {
                    label: 'AFTER_VALUES',
                    value: 'NONE',
                },
                isDisabledCallback: shouldDisableTotalsPositionRadioGroup,
                translate: ['label'],
            }),
            createRadio({
                properties: {
                    label: 'Before values',
                    value: 'BOTH',
                },
                isDisabledCallback: shouldDisableTotalsPositionRadioGroup,
                translate: ['label'],
            }),
        ],
        parseValueToComponent: ({ value }) => {
            return value !== null && value !== void 0 ? value : ShowPivotSummaryPrior.None;
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_PIVOT_SUMMARIES_POSITION,
                properties: { value: updatedValue },
            };
        },
    });
    return createLabelledView({
        properties: {
            label: 'TOTAL_POSITION',
            orientation: 'Vertical',
        },
        children: [radioGroup],
        translate: ['label'],
        ...options,
    });
};
export const createShowSubtotalsCheckboxGroup = (options = {}) => {
    return createCheckboxGroup({
        key: 'pivotSubtotalsState',
        properties: {
            label: 'charts.chartEditor.pivot.SHOW_SUB_TOTALS',
        },
        children: [
            createCheckbox({
                key: 'pivotSubtotalsState.showRowTotals',
                properties: {
                    id: 'rows',
                    label: 'charts.chartEditor.pivot.MEASURE_LAYOUT_ROW',
                },
                parseValueToComponent: ({ chartModel }) => {
                    return isRowSubTotalsEnabled(chartModel);
                },
                isDisabledCallback: shouldDisableRowSubtotalsCheckbox,
                translate: ['label'],
            }),
            createCheckbox({
                key: 'pivotSubtotalsState.showColumnTotals',
                properties: {
                    id: 'columns',
                    label: 'Columns',
                },
                parseValueToComponent: ({ chartModel }) => {
                    return isColumnSubTotalsEnabled(chartModel);
                },
                isDisabledCallback: shouldDisableColumnSubtotalsCheckbox,
                translate: ['label'],
            }),
        ],
        isDisabledCallback: shouldDisableShowSubtotals,
        parseValueFromComponent: isChecked => {
            return {
                showRowTotals: isChecked,
                showColumnTotals: isChecked,
            };
        },
        translate: ['label'],
        ...options,
    });
};
export const createShowTotalsCheckboxGroup = (options = {}) => {
    return createCheckboxGroup({
        key: 'pivotGrandTotalsState',
        properties: {
            label: 'SHOW_TOTALS',
        },
        children: [
            createCheckbox({
                key: 'pivotGrandTotalsState.showRowGrandTotals',
                properties: {
                    id: 'rows',
                    label: 'charts.chartEditor.pivot.MEASURE_LAYOUT_ROW',
                },
                parseValueToComponent: ({ chartModel }) => {
                    return isRowGrandTotalsEnabled(chartModel);
                },
                isDisabledCallback: shouldDisableShowTotalsCheckbox,
                translate: ['label'],
            }),
            createCheckbox({
                key: 'pivotGrandTotalsState.showColumnGrandTotals',
                properties: {
                    id: 'columns',
                    label: 'Columns',
                },
                parseValueToComponent: ({ chartModel }) => {
                    return isColumnGrandTotalsEnabled(chartModel);
                },
                isDisabledCallback: shouldDisableShowTotalsCheckbox,
                translate: ['label'],
            }),
        ],
        parseValueFromComponent: isChecked => {
            return {
                showRowGrandTotals: isChecked,
                showColumnGrandTotals: isChecked,
            };
        },
        isDisabledCallback: shouldDisableShowTotalsCheckbox,
        translate: ['label'],
        ...options,
    });
};
export const createDisplayValuesRadioGroup = (options = {}) => {
    const radioGroup = createRadioGroup({
        key: 'dataFieldArea',
        properties: {
            id: 'format',
        },
        children: [
            createRadio({
                properties: {
                    label: 'charts.chartEditor.pivot.MEASURE_LAYOUT_ROW',
                    value: 'row',
                },
                isDisabledCallback: shouldDisableDisplayValuesRadioGroup,
                translate: ['label'],
            }),
            createRadio({
                properties: {
                    label: 'Columns',
                    value: 'column',
                },
                isDisabledCallback: shouldDisableDisplayValuesRadioGroup,
                translate: ['label'],
            }),
        ],
        parseValueToComponent: ({ value }) => {
            if (value && value !== '')
                return value;
            return 'column';
        },
    });
    return createLabelledView({
        properties: {
            label: 'charts.chartEditor.pivot.MEASURE_LAYOUT_ENABLE_ATTRIBUTE_FLAG',
            orientation: 'Vertical',
        },
        children: [radioGroup],
        translate: ['label'],
        ...options,
    });
};
export const createDisplayValueFormatDropdown = (options = {}) => {
    return createLabelledView({
        properties: {
            label: 'charts.chartEditor.FORMAT_LABEL',
            childrenSize: 'large',
            orientation: 'Vertical',
        },
        children: [
            createDropdown({
                key: 'summaryMode',
                label: 'summaryMode',
                runTimeProperties: {
                    optionsGroups: 'TS_INPUT',
                },
                properties: {
                    optionsGroups: [],
                    dropdownWidth: 'targetWidth',
                },
                parseValueToComponent: ({ value }) => {
                    return value || NULL_SUMMARY_MODE;
                },
                isDisabledCallback: shouldDisableDisplayValueFormatDropdown,
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_PIVOT_SUMMARY_MODE,
                        properties: { mode: updatedValue },
                    };
                },
            }),
        ],
        translate: ['label'],
        ...options,
    });
};
export const createKpiComparisonColorPicker = (options = {}) => {
    return {
        elementType: ChartSettingsElementType.CHART_DATA_COLOR_PICKER,
        key: 'customColorSelectorArray',
        runTimeProperties: {
            colorItems: 'CUSTOM',
        },
        properties: {
            colorItems: [],
        },
        getRunTimeProperties: {
            colorItems: ({ currentProperties, }) => {
                return getKpiChartColorItems(currentProperties);
            },
        },
        parseValueFromComponent: (value, currentValue) => {
            const defaultCustomColors = chartSpecificConstants.DEFAULT_NEW_KPI_COLORS;
            const baseColors = _.map(defaultCustomColors, (defaultColor, index) => {
                return currentValue[index] || defaultColor;
            });
            return [value[0].color, value[1].color, ...baseColors.slice(2)];
        },
        updateCascadedValues: (parsedValue, clientState) => {
            var _a, _b, _c, _d, _e, _f;
            const [upwardColor, downwardColor] = parsedValue;
            const existingKpiColors = (_c = (_b = (_a = clientState.displayProperties) === null || _a === void 0 ? void 0 : _a.kpiDisplayProperties) === null || _b === void 0 ? void 0 : _b.kpiDisplayColorArray) !== null && _c !== void 0 ? _c : [];
            return {
                ...clientState,
                displayProperties: {
                    ...((_d = clientState.displayProperties) !== null && _d !== void 0 ? _d : {}),
                    kpiDisplayProperties: {
                        ...((_f = (_e = clientState.displayProperties) === null || _e === void 0 ? void 0 : _e.kpiDisplayProperties) !== null && _f !== void 0 ? _f : {}),
                        kpiDisplayColorArray: [
                            upwardColor,
                            downwardColor,
                            ...existingKpiColors.slice(2),
                        ],
                    },
                },
            };
        },
        isHiddenCallback: shouldHideComparisonSettings,
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.COLOR_CHANGE,
            };
        },
        ...options,
    };
};
export const createKpiAnomalyColorPicker = (options = {}) => {
    return {
        elementType: ChartSettingsElementType.CHART_DATA_COLOR_PICKER,
        key: 'customColorSelectorArray',
        runTimeProperties: {
            colorItems: 'CUSTOM',
        },
        properties: {
            colorItems: [],
        },
        getRunTimeProperties: {
            colorItems: ({ currentProperties, }) => {
                return getKpiChartColorItems(currentProperties, true);
            },
        },
        parseValueFromComponent: (value, currentValue) => {
            const defaultCustomColors = chartSpecificConstants.DEFAULT_NEW_KPI_COLORS;
            const baseColors = _.map(defaultCustomColors, (defaultColor, index) => {
                return currentValue[index] || defaultColor;
            });
            return [...baseColors.slice(0, 2), value[0].color, value[1].color];
        },
        isHiddenCallback: shouldHideAnomalyColorPicker,
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.COLOR_CHANGE,
            };
        },
        ...options,
    };
};
export const createShowLabelCheckbox = () => {
    return createCheckbox({
        key: 'showLabel',
        properties: {
            label: 'SHOW_DATE_LABEL',
        },
        translate: ['label'],
        updateCascadedValues: (updatedValue, clientState, chartModel) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const xAxisColumnId = (_a = _.first(getXAxisColumns(chartModel))) === null || _a === void 0 ? void 0 : _a.id;
            if (!xAxisColumnId)
                return clientState;
            return {
                ...clientState,
                columnProperties: {
                    ...((_b = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) !== null && _b !== void 0 ? _b : {}),
                    [xAxisColumnId]: {
                        ...((_d = (_c = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) === null || _c === void 0 ? void 0 : _c[xAxisColumnId]) !== null && _d !== void 0 ? _d : {}),
                        kpiColumnProperties: {
                            ...((_g = (_f = (_e = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) === null || _e === void 0 ? void 0 : _e[xAxisColumnId]) === null || _f === void 0 ? void 0 : _f.kpiColumnProperties) !== null && _g !== void 0 ? _g : {}),
                            showCurrentDateLabel: updatedValue,
                        },
                    },
                },
            };
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_DATE_LABEL,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createShowSparklineCheckbox = () => {
    return createCheckbox({
        key: 'showSparkline',
        properties: {
            label: 'charts.chartEditor.KPI.SHOW_SPARKLINE',
            value: true,
        },
        translate: ['label'],
        updateCascadedValues: (updatedValue, clientState, chartModel) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const yAxisColumnId = (_a = _.first(getYAxisColumns(chartModel))) === null || _a === void 0 ? void 0 : _a.id;
            if (!yAxisColumnId)
                return clientState;
            return {
                ...clientState,
                columnProperties: {
                    ...((_b = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) !== null && _b !== void 0 ? _b : {}),
                    [yAxisColumnId]: {
                        ...((_d = (_c = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) === null || _c === void 0 ? void 0 : _c[yAxisColumnId]) !== null && _d !== void 0 ? _d : {}),
                        kpiColumnProperties: {
                            ...((_g = (_f = (_e = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) === null || _e === void 0 ? void 0 : _e[yAxisColumnId]) === null || _f === void 0 ? void 0 : _f.kpiColumnProperties) !== null && _g !== void 0 ? _g : {}),
                            showSparkline: updatedValue,
                        },
                    },
                },
            };
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_SPARKLINE,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createShowComparisonDateCheckbox = () => {
    return createCheckbox({
        key: 'kpiColumnProperties.showComparisonDate',
        properties: {
            label: 'charts.chartEditorV2.KPI.SHOW_COMPARISON_DATE',
            value: true,
        },
        translate: ['label'],
        parseValueToComponent: ({ chartModel, value }) => {
            var _a, _b;
            return ((_b = (_a = getChartSpecificCustomProps(chartModel)) === null || _a === void 0 ? void 0 : _a.showComparison) !== null && _b !== void 0 ? _b : value);
        },
        updateCascadedValues: (updatedValue, clientState) => {
            var _a;
            return {
                ...clientState,
                displayProperties: {
                    ...((_a = clientState === null || clientState === void 0 ? void 0 : clientState.displayProperties) !== null && _a !== void 0 ? _a : {}),
                    showComparison: updatedValue,
                },
            };
        },
    });
};
export const createShowAbbreviatedPreviousDateCheckbox = () => {
    return createCheckbox({
        key: 'kpiColumnProperties.showAbbreviatedPreviousDate',
        properties: {
            label: 'charts.chartEditorV2.KPI.SHOW_ABBR_PREV_DATE',
            value: false,
            hasError: false,
            className: 'abbreviatedPreviousDateCheckbox',
        },
        runTimeProperties: {
            hasError: 'CUSTOM',
            label: 'CUSTOM',
        },
        getRunTimeProperties: {
            hasError: ({ chartModel }) => {
                return shouldShowAbbreviatedPreviousDateError(chartModel);
            },
            label: ({ chartModel }) => {
                return shouldShowAbbreviatedPreviousDateError(chartModel)
                    ? translate('charts.chartEditorV2.KPI.ENTER_ABBR_PREV_DATE')
                    : translate('charts.chartEditorV2.KPI.SHOW_ABBR_PREV_DATE');
            },
        },
        isHiddenCallback: shouldHideShowAbbreviatedPreviousDateCheckbox,
        isAdvanced: true,
        updateCascadedValues: (_value, clientState, chartModel, metadata) => {
            var _a, _b;
            const customProps = getKpiColumnCustomProps(chartModel, metadata === null || metadata === void 0 ? void 0 : metadata.columnId);
            let updated = clientState;
            updated = updateKpiColumnCustomPropsField(updated, chartModel, metadata === null || metadata === void 0 ? void 0 : metadata.columnId, 'customCompare', (_a = customProps === null || customProps === void 0 ? void 0 : customProps.customCompare) !== null && _a !== void 0 ? _a : null);
            updated = updateKpiColumnCustomPropsField(updated, chartModel, metadata === null || metadata === void 0 ? void 0 : metadata.columnId, 'genericCompareValue', (_b = customProps === null || customProps === void 0 ? void 0 : customProps.genericCompareValue) !== null && _b !== void 0 ? _b : null);
            return updated;
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.USE_ABBREVIATION_FOR_PREV_DATE,
                properties: { status: updatedValue },
            };
        },
    });
};
export const createAbbreviatedPreviousDateInput = () => {
    return createTextInput({
        key: 'kpiColumnProperties.abbreviatedPreviousDate',
        properties: {
            value: '',
            updateOnBlur: true,
            hasError: false,
        },
        runTimeProperties: {
            hasError: 'CUSTOM',
        },
        getRunTimeProperties: {
            hasError: ({ chartModel }) => {
                return shouldShowAbbreviatedPreviousDateError(chartModel);
            },
        },
        parseValueToComponent: ({ value, chartModel }) => {
            if (value && value !== '') {
                return value;
            }
            const kpiColumnProps = chartModel
                ? getKpiColumnProperties(chartModel)
                : undefined;
            if (value === '') {
                if (kpiColumnProps &&
                    kpiColumnProps.abbreviatedPreviousDate === '') {
                    return '';
                }
                return getDefaultAbbreviatedPreviousDateFromChartModel(chartModel);
            }
            return getDefaultAbbreviatedPreviousDateFromChartModel(chartModel);
        },
        parseValueFromComponent: (value) => {
            return value;
        },
        updateCascadedValues: (_value, clientState, chartModel, metadata) => {
            const customProps = getKpiColumnCustomProps(chartModel, metadata === null || metadata === void 0 ? void 0 : metadata.columnId);
            const updates = [
                { key: 'customCompare', value: customProps === null || customProps === void 0 ? void 0 : customProps.customCompare },
                {
                    key: 'genericCompareValue',
                    value: customProps === null || customProps === void 0 ? void 0 : customProps.genericCompareValue,
                },
            ];
            return updates.reduce((currentState, { key, value }) => {
                return updateKpiColumnCustomPropsField(currentState, chartModel, metadata === null || metadata === void 0 ? void 0 : metadata.columnId, key, value !== null && value !== void 0 ? value : null);
            }, clientState);
        },
        isAdvanced: true,
        isHiddenCallback: shouldHideShowAbbreviatedPreviousDateInput,
    });
};
export const createSparklineCheckboxForKPI = () => {
    return createCheckbox({
        key: 'kpiColumnProperties.showSparkline',
        properties: {
            label: 'charts.chartEditor.KPI.SHOW_SPARKLINE',
            value: true,
        },
        translate: ['label'],
        parseValueToComponent: ({ chartModel, value }) => {
            var _a, _b;
            return (_b = (_a = getChartSpecificCustomProps(chartModel)) === null || _a === void 0 ? void 0 : _a.showSparkline) !== null && _b !== void 0 ? _b : value;
        },
        updateCascadedValues: (updatedValue, clientState) => {
            var _a;
            return {
                ...clientState,
                displayProperties: {
                    ...((_a = clientState === null || clientState === void 0 ? void 0 : clientState.displayProperties) !== null && _a !== void 0 ? _a : {}),
                    showSparkline: updatedValue,
                },
            };
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SPARKLINE,
                properties: { status: updatedValue ? 'show' : 'hide' },
            };
        },
    });
};
export const createShowComparisonCheckbox = () => {
    return createCheckbox({
        key: 'showComparison',
        properties: {
            label: 'charts.chartEditor.KPI.SHOW_COMPARISON',
        },
        translate: ['label'],
        updateCascadedValues: (updatedValue, clientState, chartModel) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const xAxisColumnId = (_a = _.first(getXAxisColumns(chartModel))) === null || _a === void 0 ? void 0 : _a.id;
            if (!xAxisColumnId)
                return clientState;
            return {
                ...clientState,
                columnProperties: {
                    ...((_b = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) !== null && _b !== void 0 ? _b : {}),
                    [xAxisColumnId]: {
                        ...((_d = (_c = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) === null || _c === void 0 ? void 0 : _c[xAxisColumnId]) !== null && _d !== void 0 ? _d : {}),
                        kpiColumnProperties: {
                            ...((_g = (_f = (_e = clientState === null || clientState === void 0 ? void 0 : clientState.columnProperties) === null || _e === void 0 ? void 0 : _e[xAxisColumnId]) === null || _f === void 0 ? void 0 : _f.kpiColumnProperties) !== null && _g !== void 0 ? _g : {}),
                            showComparisonDate: updatedValue,
                        },
                    },
                },
            };
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_COMPARISON,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createShowAnomalyCheckbox = () => {
    return createCheckbox({
        key: 'showAnomalies',
        properties: {
            label: 'SHOW_ANOMALY',
            tooltipContent: 'charts.chartEditor.KPI.SHOW_ANOMALIES_INFO_TEXT',
        },
        runTimeProperties: {
            indeterminate: 'TS_INPUT',
        },
        parseValueToComponent: ({ value }) => {
            return value !== null && value !== void 0 ? value : true;
        },
        isDisabledCallback: shouldDisableShowAnomalyCheckbox,
        translate: ['label', 'tooltipContent'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_ANOMALY,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createShowEnableAnalyseCheckbox = () => {
    return createCheckbox({
        key: 'showAnalyseChangeCta',
        properties: {
            label: 'ENABLE_ANALYSIS',
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_ANALYZE_EXCHANGE_CTA,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createCustomComparisonDropdown = (options = {}) => {
    const isKpiColumnSettings = options.isKpiColumnSettings === true;
    const dropdownConfig = {
        key: 'customCompare',
        runTimeProperties: {
            optionsGroups: 'TS_INPUT',
        },
        properties: {
            value: TupleType.PrevAvailable,
            variant: 'richSubtext',
        },
        runTimeValidation: ({ value: selectedOption, chartModel }) => {
            const refTuple = _.find(getRefTuple(chartModel, selectedOption));
            if (!refTuple) {
                return {
                    title: getErrorTitleForCustomCompare(ErrorCodes.COMPARISON_DATE_OUT_OF_RANGE),
                    description: getErrorDescriptionForCustomCompare({
                        alertMessageType: ErrorCodes.COMPARISON_DATE_OUT_OF_RANGE,
                        refTupleType: selectedOption,
                    }),
                };
            }
            return null;
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.CHANGE_CUSTOM_COMPARE,
                properties: { customCompare: updatedValue },
            };
        },
    };
    if (isKpiColumnSettings) {
        dropdownConfig.parseValueToComponent = ({ chartModel, column, customPropsValue, value, }) => {
            var _a, _b, _c, _d;
            const fallbackValue = TupleType.PrevAvailable;
            if (!chartModel) {
                return ((_b = (_a = parseCustomProps(customPropsValue)) === null || _a === void 0 ? void 0 : _a.customCompare) !== null && _b !== void 0 ? _b : fallbackValue);
            }
            const optionsGroups = getCustomComparisonOptions(chartModel, isKPIChartEnhancementsEnabled());
            const optionIds = optionsGroups
                .flatMap(group => group.options)
                .map(option => String(option.id));
            const customProps = getKpiColumnCustomProps(chartModel, column === null || column === void 0 ? void 0 : column.id);
            const customCompareFromProps = (_c = parseCustomProps(customProps)) === null || _c === void 0 ? void 0 : _c['customCompare'];
            const compareValue = value !== fallbackValue ? value : null;
            const resolvedValue = customCompareFromProps !== null && customCompareFromProps !== void 0 ? customCompareFromProps : compareValue;
            if (resolvedValue && optionIds.includes(resolvedValue)) {
                return resolvedValue;
            }
            if (optionIds.includes(fallbackValue)) {
                return fallbackValue;
            }
            return ((_d = optionIds[0]) !== null && _d !== void 0 ? _d : fallbackValue);
        };
        dropdownConfig.parseValueFromComponent = (value) => value;
        dropdownConfig.updateCascadedValues = (value, clientState, chartModel, metadata) => updateKpiColumnCustomPropsField(clientState, chartModel, metadata === null || metadata === void 0 ? void 0 : metadata.columnId, 'customCompare', value);
    }
    return createLabelledView({
        properties: {
            label: isKpiColumnSettings
                ? 'charts.chartEditor.KPI.CUSTOM_COMPARISON_PERIOD'
                : 'charts.chartEditor.KPI.CUSTOM_COMPARISON',
            orientation: 'Vertical',
        },
        children: [createDropdown(dropdownConfig)],
        ...(!isKpiColumnSettings && {
            isHiddenCallback: shouldHideComparisonSettings,
        }),
        translate: ['label'],
        ...options,
    });
};
export const createCustomComparisonInput = () => {
    return createLabelledView({
        key: 'genericCompareValue',
        runTimeProperties: {
            label: 'CUSTOM',
        },
        getRunTimeProperties: {
            label: ({ chartModel, currentProperties, }) => {
                const xAxisColumn = _.first(getXAxisColumns(chartModel));
                const customCompareLabel = mapTimeBucketToCategory(getTimeBucket(xAxisColumn), currentProperties === 1).toLowerCase();
                return translate('chartSettingsV2.KPI.CUSTOM_COMPARISON', {
                    timebucket: customCompareLabel,
                });
            },
        },
        properties: {
            childrenSize: 'small',
        },
        children: [
            createNumberInput({
                key: 'genericCompareValue',
                properties: {
                    value: 1,
                    min: 1,
                    step: 1,
                    precision: 0,
                    updateOnBlur: true,
                    parser: (v) => v.replace(/[^0-9]/g, ''),
                },
                parseValueToComponent: ({ chartModel, column, value }) => {
                    var _a, _b;
                    if (!chartModel) {
                        return ((_a = getGenericCompareValueFromCustomProps(value)) !== null && _a !== void 0 ? _a : 1);
                    }
                    const customProps = getKpiColumnCustomProps(chartModel, column === null || column === void 0 ? void 0 : column.id);
                    return ((_b = getGenericCompareValueFromCustomProps(customProps)) !== null && _b !== void 0 ? _b : 1);
                },
                parseValueFromComponent: value => String(value),
                runTimeValidation: ({ value, chartModel }) => {
                    var _a, _b, _c, _d, _e;
                    const limit = ((_e = (_d = (_c = (_b = (_a = chartModel.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.kpiData) === null || _c === void 0 ? void 0 : _c.offsetLimits) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.offsetLimit) || Number.MAX_SAFE_INTEGER;
                    if (Number(value) > limit) {
                        return {
                            title: getErrorTitleForCustomCompare(ErrorCodes.MAX_OFFSET_LIMIT),
                            description: getErrorDescriptionForCustomCompare({
                                alertMessageType: ErrorCodes.MAX_OFFSET_LIMIT,
                                chartModel,
                            }),
                        };
                    }
                    return null;
                },
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.CHANGE_CUSTOM_COMPARE,
                        properties: { customCompare: updatedValue },
                    };
                },
                updateCascadedValues: (value, clientState, chartModel, metadata) => {
                    const columnId = metadata === null || metadata === void 0 ? void 0 : metadata.columnId;
                    const updatedGenericCompareValue = updateKpiColumnCustomPropsField(clientState, chartModel, columnId, 'genericCompareValue', String(value));
                    const updatedCustomCompare = updateKpiColumnCustomPropsField(updatedGenericCompareValue, chartModel, columnId, 'customCompare', TupleType.Custom);
                    return updatedCustomCompare;
                },
            }),
        ],
        isHiddenCallback: shouldHideCustomComparisonInput,
        translate: ['label'],
    });
};
const createShowCurrentDateLabelCheckbox = () => {
    return createCheckbox({
        key: 'kpiColumnProperties.showCurrentDateLabel',
        properties: {
            label: 'charts.chartEditor.kpiEnhanced.current_date_label',
        },
        translate: ['label'],
        isAdvanced: true,
        parseValueToComponent: ({ chartModel, value }) => {
            var _a, _b;
            return (_b = (_a = getChartSpecificCustomProps(chartModel)) === null || _a === void 0 ? void 0 : _a.showLabel) !== null && _b !== void 0 ? _b : value;
        },
        updateCascadedValues: (updatedValue, clientState) => {
            var _a;
            return {
                ...clientState,
                displayProperties: {
                    ...((_a = clientState === null || clientState === void 0 ? void 0 : clientState.displayProperties) !== null && _a !== void 0 ? _a : {}),
                    showLabel: updatedValue,
                },
            };
        },
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_DATE_LABEL,
                properties: {
                    propertyName: 'current_date',
                    propertyValue: updatedValue,
                },
            };
        },
    });
};
const createShowPreviousDateLabelCheckbox = () => {
    return createCheckbox({
        key: 'kpiColumnProperties.showPreviousDateLabel',
        properties: {
            label: 'charts.chartEditor.kpiEnhanced.previous_date_label',
        },
        translate: ['label'],
        isAdvanced: true,
    });
};
const createShowPreviousValueCheckbox = () => {
    return createCheckbox({
        key: 'kpiColumnProperties.showPreviousValue',
        properties: {
            label: 'charts.chartEditor.kpiEnhanced.previous_value',
        },
        translate: ['label'],
        isAdvanced: true,
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_DATE_LABEL,
                properties: {
                    propertyName: 'previous_value',
                    propertyValue: updatedValue,
                },
            };
        },
    });
};
export const createShowChangeCheckbox = () => {
    return createCheckbox({
        key: 'kpiDisplayProperties.showChange',
        properties: {
            label: 'charts.chartEditor.kpiEnhanced.change.checkbox',
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TOGGLE_SHOW_CHANGE,
                properties: { status: updatedValue },
            };
        },
    });
};
export const createKpiDisplayColorPicker = (options = {}) => {
    const DEFAULT_UPWARD_COLOR = blinkConstants.gradientColorsColorPalette.GREEN[0];
    const DEFAULT_DOWNWARD_COLOR = blinkConstants.gradientColorsColorPalette.RED[0];
    return {
        elementType: ChartSettingsElementType.CHART_DATA_COLOR_PICKER,
        key: 'kpiDisplayProperties.kpiDisplayColorArray',
        runTimeProperties: {
            colorItems: 'CUSTOM',
        },
        properties: {
            colorItems: [],
            showFlipColors: true,
            hideResetButton: true,
        },
        getRunTimeProperties: {
            colorItems: ({ currentProperties = [], }) => {
                const colors = [
                    currentProperties[0] || DEFAULT_UPWARD_COLOR,
                    currentProperties[1] || DEFAULT_DOWNWARD_COLOR,
                ];
                return [
                    {
                        color: colors[0],
                        serieName: translate('charts.chartEditor.kpiEnhanced.change.color.upwards'),
                    },
                    {
                        color: colors[1],
                        serieName: translate('charts.chartEditor.kpiEnhanced.change.color.downwards'),
                    },
                ];
            },
        },
        parseValueFromComponent: (value, currentValue) => {
            const currentArray = currentValue || [];
            return [value[0].color, value[1].color, ...currentArray.slice(2)];
        },
        updateCascadedValues: (parsedValue, clientState) => {
            var _a, _b, _c;
            const [upwardColor, downwardColor] = parsedValue;
            const existingCustomColors = (_b = (_a = clientState.displayProperties) === null || _a === void 0 ? void 0 : _a.customColorSelectorArray) !== null && _b !== void 0 ? _b : [];
            return {
                ...clientState,
                displayProperties: {
                    ...((_c = clientState.displayProperties) !== null && _c !== void 0 ? _c : {}),
                    customColorSelectorArray: [
                        upwardColor,
                        downwardColor,
                        ...existingCustomColors.slice(2),
                    ],
                },
            };
        },
        isHiddenCallback: shouldHideChangeAsDropdown,
        isAdvanced: true,
        ...options,
    };
};
export const createKpiAnomalyColorPickerLinkedtoChangeColorPicker = (options = {}) => {
    const defaultColors = chartSpecificConstants.DEFAULT_NEW_KPI_COLORS;
    return {
        elementType: ChartSettingsElementType.CHART_DATA_COLOR_PICKER,
        key: 'kpiDisplayProperties.kpiDisplayColorArray',
        runTimeProperties: {
            colorItems: 'CUSTOM',
            linkedColorItems: 'CUSTOM',
            isLinkedToChangeColor: 'CUSTOM',
        },
        properties: {
            colorItems: [],
            linkToChangeColorPicker: true,
            isLinkedToChangeColor: true,
            linkedToKey: 'kpiDisplayProperties.kpiDisplayColorArray',
        },
        getRunTimeProperties: {
            colorItems: ({ currentProperties = [], chartModel, }) => {
                var _a;
                const customColors = (_a = chartModel === null || chartModel === void 0 ? void 0 : chartModel.vizProp) === null || _a === void 0 ? void 0 : _a.customColorSelectorArray;
                return [
                    {
                        color: (customColors === null || customColors === void 0 ? void 0 : customColors[ABOVE_EXPECTED_COLOR_INDEX]) ||
                            currentProperties[ABOVE_EXPECTED_COLOR_INDEX] ||
                            defaultColors[ABOVE_EXPECTED_COLOR_INDEX],
                        serieName: translate('ABOVE_EXPECTED_ANOMALY'),
                    },
                    {
                        color: (customColors === null || customColors === void 0 ? void 0 : customColors[BELOW_EXPECTED_COLOR_INDEX]) ||
                            currentProperties[BELOW_EXPECTED_COLOR_INDEX] ||
                            defaultColors[BELOW_EXPECTED_COLOR_INDEX],
                        serieName: translate('BELOW_EXPECTED_ANOMALY'),
                    },
                ];
            },
            linkedColorItems: ({ currentProperties = [], }) => {
                return [
                    {
                        color: currentProperties[positiveComparisionColorIndex] ||
                            defaultColors[positiveComparisionColorIndex],
                        serieName: translate('charts.chartEditor.kpiEnhanced.change.color.upwards'),
                    },
                    {
                        color: currentProperties[negativeComparisionColorIndex] ||
                            defaultColors[negativeComparisionColorIndex],
                        serieName: translate('charts.chartEditor.kpiEnhanced.change.color.downwards'),
                    },
                ];
            },
            isLinkedToChangeColor: ({ chartModel, }) => {
                var _a, _b, _c, _d;
                return ((_d = (_c = (_b = (_a = chartModel === null || chartModel === void 0 ? void 0 : chartModel.vizProp) === null || _a === void 0 ? void 0 : _a.chartProperties) === null || _b === void 0 ? void 0 : _b.kpiDisplayProperties) === null || _c === void 0 ? void 0 : _c.linkChangeColorsWithAnomaly) !== null && _d !== void 0 ? _d : true);
            },
        },
        parseValueFromComponent: (value, currentValue) => {
            var _a, _b;
            const currentArray = currentValue || [];
            return [
                (_a = currentArray[positiveComparisionColorIndex]) !== null && _a !== void 0 ? _a : defaultColors[positiveComparisionColorIndex],
                (_b = currentArray[negativeComparisionColorIndex]) !== null && _b !== void 0 ? _b : defaultColors[negativeComparisionColorIndex],
                value[0].color,
                value[1].color,
            ];
        },
        updateCascadedValues: (parsedValue, newVizProp) => {
            var _a, _b, _c;
            const customArray = ((_a = newVizProp.displayProperties) === null || _a === void 0 ? void 0 : _a.customColorSelectorArray) || [];
            _.set(newVizProp, 'displayProperties.customColorSelectorArray', [
                (_b = customArray[positiveComparisionColorIndex]) !== null && _b !== void 0 ? _b : parsedValue[positiveComparisionColorIndex],
                (_c = customArray[negativeComparisionColorIndex]) !== null && _c !== void 0 ? _c : parsedValue[negativeComparisionColorIndex],
                parsedValue[ABOVE_EXPECTED_COLOR_INDEX],
                parsedValue[BELOW_EXPECTED_COLOR_INDEX],
            ]);
            const isLinked = parsedValue[positiveComparisionColorIndex] ===
                parsedValue[ABOVE_EXPECTED_COLOR_INDEX] &&
                parsedValue[negativeComparisionColorIndex] ===
                    parsedValue[BELOW_EXPECTED_COLOR_INDEX];
            _.set(newVizProp, 'displayProperties.kpiDisplayProperties.linkChangeColorsWithAnomaly', isLinked);
            return newVizProp;
        },
        getMixpanelConfig: () => {
            return {
                eventName: userActionTypeEnum.COLOR_CHANGE,
            };
        },
        isAdvanced: true,
        isHiddenCallback: shouldHideAnomalyColorPicker,
        ...options,
    };
};
export const createAnomalyLabelledViewForKPI = () => {
    return createLabelledView({
        properties: {
            spacing: 'ignore',
            label: 'charts.chartEditor.section.CORTEX',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createShowAnomalyCheckbox(),
            createKpiAnomalyColorPickerLinkedtoChangeColorPicker(),
        ],
        isHiddenCallback: shouldHideAnomalySettings,
        translate: ['label'],
    });
};
export const createShowChangeAsDropdown = () => {
    return createLabelledView({
        properties: {
            label: 'charts.chartEditor.kpiEnhanced.change.changeShownAs.section',
            orientation: 'Vertical',
        },
        children: [
            createDropdown({
                key: 'kpiDisplayProperties.showChangeAs',
                properties: {
                    orientation: 'Vertical',
                    optionsGroups: [
                        {
                            options: [
                                {
                                    id: ShowChangeAs.Percent,
                                    label: 'charts.chartEditor.kpiEnhanced.change.changeShownAs.percentage',
                                },
                                {
                                    id: ShowChangeAs.Absolute,
                                    label: 'charts.chartEditor.kpiEnhanced.change.changeShownAs.absolute',
                                },
                            ],
                        },
                    ],
                    dropdownWidth: 'targetWidth',
                    value: ShowChangeAs.Percent,
                },
                translate: ['label', 'optionsGroups.options.label'],
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.TOGGLE_CHANGE_DISPLAY_FORMAT,
                        properties: { format: updatedValue },
                    };
                },
            }),
        ],
        translate: ['label'],
        isHiddenCallback: shouldHideChangeAsDropdown,
    });
};
export const createChangeInterpretationDropdown = () => {
    return createLabelledView({
        properties: {
            label: 'charts.chartEditor.kpiEnhanced.change.interpretation.section',
            orientation: 'Vertical',
        },
        children: [
            createDropdown({
                key: 'kpiDisplayProperties.changeInterpretation',
                properties: {
                    optionsGroups: [
                        {
                            options: [
                                {
                                    id: ChangeInterpretation.UpwardIsGood,
                                    label: 'charts.chartEditor.kpiEnhanced.change.interpretation.upwardsIsGood',
                                },
                                {
                                    id: ChangeInterpretation.DownwardIsGood,
                                    label: 'charts.chartEditor.kpiEnhanced.change.interpretation.downwardsIsGood',
                                },
                                {
                                    id: ChangeInterpretation.Neutral,
                                    label: 'charts.chartEditor.kpiEnhanced.change.interpretation.changeIsNeutral',
                                },
                            ],
                        },
                    ],
                    dropdownWidth: 'targetWidth',
                    value: ChangeInterpretation.UpwardIsGood,
                },
                translate: ['label', 'optionsGroups.options.label'],
                getMixpanelConfig: ({ updatedValue }) => {
                    const interpretationMap = {
                        [ChangeInterpretation.UpwardIsGood]: 'Upward',
                        [ChangeInterpretation.DownwardIsGood]: 'Downward',
                        [ChangeInterpretation.Neutral]: 'Neutral',
                    };
                    return {
                        eventName: userActionTypeEnum.TOGGLE_CHANGE_INTERPRETATION,
                        properties: {
                            status: interpretationMap[updatedValue] || updatedValue,
                        },
                    };
                },
            }),
        ],
        translate: ['label'],
        isHiddenCallback: shouldHideChangeAsDropdown,
        isAdvanced: true,
    });
};
export const createChangeSectionLabelledView = () => {
    return createLabelledView({
        properties: {
            spacing: 'ignore',
            label: 'charts.chartEditor.kpiEnhanced.change.section',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
            childrenSize: 'large',
        },
        children: [
            createShowChangeCheckbox(),
            createShowChangeAsDropdown(),
            createKpiDisplayColorPicker(),
            createChangeInterpretationDropdown(),
        ],
        translate: ['label'],
    });
};
export const createComparisonLabelledView = () => {
    return createLabelledView({
        properties: {
            spacing: 'ignore',
            label: 'COMPARISON',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createShowComparisonCheckbox(),
            createKpiComparisonColorPicker(),
            createCustomComparisonDropdown(),
            createCustomComparisonInput(),
        ],
        translate: ['label'],
    });
};
export const createComparisonLabelledViewForKPI = () => {
    return createLabelledView({
        properties: {
            spacing: 'ignore',
            label: 'COMPARISON',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [
            createShowComparisonDateCheckbox(),
            createCustomComparisonDropdown({ isKpiColumnSettings: true }),
            createCustomComparisonInput(),
            createShowCurrentDateLabelCheckbox(),
            createShowPreviousDateLabelCheckbox(),
            createShowPreviousValueCheckbox(),
            createShowAbbreviatedPreviousDateCheckbox(),
            createAbbreviatedPreviousDateInput(),
        ],
        translate: ['label'],
    });
};
export const createThemeSelectorDropdown = () => {
    return createLabelledView({
        properties: {
            label: 'THEME',
            childrenSize: 'medium',
        },
        children: [
            createDropdown({
                key: 'theme',
                properties: {
                    optionsGroups: [
                        {
                            options: [
                                {
                                    id: TableTheme.Outline,
                                    label: 'tables.tableEditor.outlineLabel',
                                },
                                {
                                    id: TableTheme.Row,
                                    label: 'tables.tableEditor.rowLabel',
                                },
                                {
                                    id: TableTheme.Zebra,
                                    label: 'tables.tableEditor.zebraLabel',
                                },
                            ],
                        },
                    ],
                    dropdownWidth: 'targetWidth',
                    value: TableTheme.Outline,
                },
                translate: ['optionsGroups.options.label'],
                getMixpanelConfig: ({ updatedValue }) => {
                    return {
                        eventName: userActionTypeEnum.TABLE_THEME,
                        properties: {
                            themeType: updatedValue,
                        },
                    };
                },
            }),
        ],
        translate: ['label'],
    });
};
export const createContentDensityRadioGroup = () => {
    const radioGroup = createRadioGroup({
        key: 'density',
        properties: {
            label: 'CONTENT_DENSITY',
            id: 'density',
            value: 'REGULAR',
        },
        children: [
            createRadio({
                properties: {
                    label: 'tables.tableEditor.regularLabel',
                    value: 'REGULAR',
                },
                translate: ['label'],
            }),
            createRadio({
                properties: {
                    label: 'tables.tableEditor.compactLabel',
                    value: 'COMPACT',
                },
                translate: ['label'],
            }),
        ],
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TABLE_CONTENT_DENSITY,
                properties: {
                    densityType: updatedValue,
                },
            };
        },
    });
    return createLabelledView({
        properties: {
            label: 'CONTENT_DENSITY',
            orientation: 'Vertical',
        },
        children: [radioGroup],
        translate: ['label'],
    });
};
export const createDisplayFooterCheckbox = () => {
    return createCheckbox({
        key: 'showFooter',
        properties: {
            label: 'DISPLAY_FOOTER',
            value: true,
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TABLE_FOOTER,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createTextWrapToggle = () => {
    return createElement(ChartSettingsElementType.TEXT_WRAP_TOGGLE, {
        key: 'wrapHeader',
        parseValueToComponent: ({ value }) => {
            return value === false ? 'clip' : 'wrap';
        },
        parseValueFromComponent: (value) => {
            return value === 'wrap';
        },
        properties: {
            label: 'tables.tableEditor.wrapOptions.header',
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.TABLE_TEXT_WRAP,
                properties: { wrapType: updatedValue },
            };
        },
    });
};
export const createDisplaySummaryCheckbox = () => {
    return createCheckbox({
        isAnswerProperty: true,
        key: 'headlineVisibility',
        properties: {
            label: 'Display_Summary',
        },
        runTimeProperties: {
            value: 'TS_INPUT',
        },
        isDisabledCallback: shouldDisableDisplaySummaryCheckbox,
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.COLUMN_SUMMARY,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createDisplayAllSummaryCheckbox = () => {
    return createCheckbox({
        isAnswerProperty: true,
        key: 'allHeadlineVisibility',
        properties: {
            label: 'DISPLAY_ALL_SUMMARIES',
        },
        runTimeProperties: {
            value: 'TS_INPUT',
        },
        translate: ['label'],
        getMixpanelConfig: ({ updatedValue }) => {
            return {
                eventName: userActionTypeEnum.ALL_COLUMN_SUMMARY,
                properties: { enabled: updatedValue },
            };
        },
    });
};
export const createTableSummaryNumberFormatter = (options = {}) => {
    return createNumberFormatter({
        key: 'columnProperty.summariesNumberFormatConfig',
        isAnswerProperty: true,
        properties: {
            typeProps: {
                ariaLabel: 'number-type',
            },
            subTypeProps: {
                ariaLabel: 'number-subtype',
            },
            formatProps: {
                ariaLabel: 'number-format',
            },
        },
        runTimeProperties: {
            customFormatPattern: 'TS_INPUT',
            isCustomCurrency: 'TS_INPUT',
        },
        parseValueToComponent: ({ allSummaryVizes, column }) => {
            var _a, _b, _c;
            const headlineViz = allSummaryVizes === null || allSummaryVizes === void 0 ? void 0 : allSummaryVizes.find(summaryViz => summaryViz.headlineColumn.id === column.id);
            if (!headlineViz) {
                return null;
            }
            return ((_c = (_b = (_a = headlineViz === null || headlineViz === void 0 ? void 0 : headlineViz.vizProp) === null || _a === void 0 ? void 0 : _a.columnProperty) === null || _b === void 0 ? void 0 : _b.summariesNumberFormatConfig) !== null && _c !== void 0 ? _c : getSummariesFormatConfig(headlineViz));
        },
        getMixpanelConfig: ({ updatedValue, previousValue }) => {
            return getNumberFormatMixPanelConfig(updatedValue, previousValue, userActionTypes.NUMBER_FORMAT.actionParams.target.SUMMARY);
        },
        isHiddenCallback: shouldHideTableSummaryNumberFormatter,
        ...options,
    });
};
export const createTableSummaryLabelledView = () => {
    return createLabelledView({
        properties: {
            label: 'SUMMARY',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [createDisplaySummaryCheckbox()],
        translate: ['label'],
    });
};
export const createAnomalyLabelledView = () => {
    return createLabelledView({
        properties: {
            spacing: 'ignore',
            label: 'charts.chartEditor.section.CORTEX',
            orientation: 'Vertical',
            labelColor: Colors.grayLight,
            labelVariant: 'p-small-bold',
        },
        children: [createShowAnomalyCheckbox(), createKpiAnomalyColorPicker()],
        isHiddenCallback: shouldHideAnomalySettings,
        translate: ['label'],
    });
};
export const createBackgroundAccordionItem = (children = []) => {
    return createAccordionItem({
        properties: {
            header: 'BACKGROUND',
        },
        translate: ['header'],
        children,
    });
};
export const createRegressionLineAccordionItem = (children = []) => {
    return createAccordionItem({
        properties: {
            header: 'charts.chartEditor.SHOW_REGRESSION_LINE',
        },
        translate: ['header'],
        children,
    });
};
export const createAxisNameAccordionItem = (children = []) => {
    return createAccordionItem({
        properties: {
            header: 'AXIS_NAME',
        },
        translate: ['header'],
        children,
    });
};
export const createValueLabelAccordionItem = (children = []) => {
    return createAccordionItem({
        properties: {
            header: 'VALUE_LABEL',
        },
        translate: ['header'],
        children,
    });
};
export const createAxisLinesAccordionItem = (children = []) => {
    return createAccordionItem({
        properties: {
            header: 'AXIS_LINES',
        },
        translate: ['header'],
        children,
    });
};
export const createIntervalsAccordionItem = (children = []) => {
    return createAccordionItem({
        properties: {
            header: 'INTERVALS',
        },
        translate: ['header'],
        children,
    });
};
//# sourceMappingURL=common-elements.js.map